import React, { useEffect, useLayoutEffect, useRef, useState, useCallback } from 'react';
import api from '../services/api';
import './RandevuEkrani.css';

// "Randevu Ekranı" — VB6 RANDEVUFORM.frm karşılığı (kullanıcı talebi: 2026-09-05).
// Yetki: TEKN.YETK_WEB_8 (menü ve route src/yetki.js + App.js'te bu numaraya bağlı).
//
// TASARIM REVİZYONU (2026-09-18): kullanıcılar VB6 ekranına alışkın, düzen ona benzetildi.
//   - SOL sütun: uzman seçimi (Daimi / Part Time / Tümü) ve altında hasta seçimi. Hiçbir öğe
//     ızgaraya taşmaz.
//   - ORTA: 7 günlük çizelge; altında VB6'daki renk açıklaması, renkler VB6'nın pastel hali.
//   - İşlem pencereleri (Randevu Ver, Saat Kapama, Randevu Detayı) MODAL: yalnızca
//     tetiklenince açılır. VB6'daki gibi boş saate tıklanınca hasta SEÇİLİYSE Randevu Ver,
//     seçili DEĞİLSE Saat Kapama açılır.
//
// Izgara VB6'daki gibi: TEK UZMAN × 7 GÜN. Satırlar uzmanın kendi saat listesinden gelir
// (RANDEVU_GUNLER), aralık uzmanın randevu modeline göre 10/15/20/30/60 dakikadır.
//
// DİKKAT: randevu vermek yalnızca RAND'a satır atmak değildir — VB6'daki gibi
// MASTERJOB + RAND + KABUL + KABULAYR yazılır ve hastanın satış hakkı TÜKETİLİR.

// Izgara gün başlığı: "14 Eylül Pazartesi", "15 Eylül Salı" ... (kullanıcı talebi: 2026-09-20).
const GUN_ADI = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'];
const GUN_UZUN = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
const AY_UZUN = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos',
  'Eylül', 'Ekim', 'Kasım', 'Aralık'];

// VB6 formunun renk kutuları (Resim-2), biraz pastelleştirilmiş hali. Sunucunun durum
// kodları VB6'nın kategorilerine eşlenir: izin ve mesai dışı saatler VB6'da aynı
// "ÇALIŞMADIĞI SAATLER" rengindedir.
const RENK = {
  bos:        '#FFFFFF',
  calismadi:  '#F4B8EF',
  tatil:      '#8ED5D5',
  gelmedi:    '#F5ABAB',
  notrandevu: '#FFD4A3',
  kapali:     '#9B9B9B',
  sistemdisi: '#5B6791',
  geldi:      '#C8F1C8',
  // Çıkışı yapılmış (ön faturası kesilmiş) randevu — GELDİ'nin bir tık koyusu (2026-09-20).
  cikis:      '#8ED88E',
};

const DURUM = {
  bos:        { ad: 'Boş',               renk: RENK.bos },
  geldi:      { ad: 'Randevusuna Geldi', renk: RENK.geldi },
  cikis:      { ad: 'Çıkış Yapıldı',     renk: RENK.cikis },
  gelmedi:    { ad: 'Randevusuna Gelmedi', renk: RENK.gelmedi },
  notrandevu: { ad: 'Not Randevusu',     renk: RENK.notrandevu },
  kapali:     { ad: 'Kapalı',            renk: RENK.kapali, koyu: true },
  izinli:     { ad: 'Çalışmadığı saat',  renk: RENK.calismadi },
  mesaidisi:  { ad: 'Mesai Dışı',        renk: RENK.calismadi },
  tatil:      { ad: 'Resmi Tatil',       renk: RENK.tatil },
  global:     { ad: 'Sistem Dışı',       renk: RENK.sistemdisi, koyu: true },
};

// Izgaranın altındaki açıklama — VB6'daki sıra ve adlarla.
// Kullanıcının istediği sıra (2026-09-19); 9 eşit sütunda (2026-09-20: Çıkış Yapıldı eklendi).
const LEJANT = [
  ['BOŞ', RENK.bos], ['KAPALI', RENK.kapali], ['Mesai Dışı', RENK.calismadi],
  ['Sistem Dışı', RENK.sistemdisi], ['Resmi Tatil', RENK.tatil],
  ['Randevusuna Gelmedi', RENK.gelmedi], ['Randevusuna Geldi', RENK.geldi],
  ['Çıkış Yapıldı', RENK.cikis], ['Not Randevusu', RENK.notrandevu],
];

// Bu durumlarda hücreye yeni randevu verilemez.
const YAZILAMAZ = ['izinli', 'mesaidisi', 'tatil', 'global'];

const kisaTarih = (iso) => `${Number(iso.slice(8, 10))} ${AY_UZUN[Number(iso.slice(5, 7)) - 1]}`;

const bugunIso = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

// "2026-09-16" -> "16 Eylül 2026 ( Çarşamba )" — VB6'daki yazım.
function uzunTarih(iso) {
  if (!iso) return '';
  const d = new Date(String(iso).slice(0, 10) + 'T00:00:00');
  return `${d.getDate()} ${AY_UZUN[d.getMonth()]} ${d.getFullYear()} ( ${GUN_UZUN[d.getDay()]} )`;
}

// "10:30" + 90 dk -> "12:00"
function saatEkle(saat, dakika) {
  const [s, d] = String(saat).split(':').map(Number);
  const t = s * 60 + d + dakika;
  return `${String(Math.floor(t / 60) % 24).padStart(2, '0')}:${String(t % 60).padStart(2, '0')}`;
}

// VB6 GEREKTIGIKADAR'ın karşılığı: seçilen hücreden AŞAĞIYA doğru kaç periyot kesintisiz boş?
// Süre seçenekleri bununla sınırlanır, yoksa alttaki kaydın üstüne taşan randevu verilebilir
// (kullanıcı bildirimi: 2026-09-05). Sunucu da kaydederken aynı hesabı bağımsız yapıyor.
//
// haricRandId verilirse (mevcut randevu düzenlenirken) o randevunun kendi satırları boş sayılır.
function musaitPeriyot(hafta, satir, sutun, haricRandId) {
  if (!hafta) return 1;
  let adet = 0;
  for (let r = satir; r < hafta.saatler.length; r++) {
    const h = hafta.hucreler[r][sutun];
    const bos = h.durum === 'bos' || (haricRandId != null && h.randId === haricRandId);
    if (!bos) break;
    adet++;
  }
  return Math.max(adet, 1);
}

// NOT RANDEVUSU penceresi (kullanıcı kuralı: 2026-09-21): 09:00–09:45 arası saatler her zaman
// not randevusudur ve hiçbir randevu kuralı uygulanmaz; bu saatlerin dışında not randevusu yoktur.
// Sunucudaki karşılığı: RandevuYazmaServisi.NotSaatiMi.
const notSaatiMi = (saat) => !!saat && saat >= '09:00' && saat <= '09:45';

const bosYeni = {
  planlamaId: '', tarifeKod: '', dkSay: 1,
  ozelIstekKod: 0, aciklama: '', odaAdi: '', notRandevu: false, provizyonNo: '',
  hastayaSms: false, hastaSmsMetni: '', hnSms: false,
};

// "2026-10-11T00:00:00" -> "11.10.2026"
const trTarih = (d) => (d ? `${String(d).slice(8, 10)}.${String(d).slice(5, 7)}.${String(d).slice(0, 4)}` : '');

const para = (n) => (n == null ? '' : Number(n).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

// Kullanılmamış haklardan SIRASI GELENLER: her paketin (ORTAK_MASTERPROTNO) her hizmetinde en
// küçük numaralı hak. Sunucudaki "EN ÜSTTEKİ HAKKI seçiniz" kuralının arayüzdeki karşılığı.
function siradakiler(haklar) {
  const enKucuk = new Map();
  (haklar || []).filter(h => !h.kullanildi).forEach(h => {
    const k = `${h.protokol}|${h.hizmet}`;
    if (!enKucuk.has(k) || h.id < enKucuk.get(k)) enKucuk.set(k, h.id);
  });
  return new Set(enKucuk.values());
}

function RandevuEkrani() {
  const [uzmanlar, setUzmanlar] = useState([]);
  const [kapsam, setKapsam] = useState('daimi');
  const [dokKod, setDokKod] = useState('');
  const [tarih, setTarih] = useState(bugunIso());
  const [hafta, setHafta] = useState(null);
  const [secenek, setSecenek] = useState(null);
  const [secili, setSecili] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState('');
  const [bilgi, setBilgi] = useState('');

  // Açık pencere: 'yeni' | 'kapat' | 'detay' | null
  const [modal, setModal] = useState(null);
  const [modalHata, setModalHata] = useState('');
  const [yeni, setYeni] = useState(bosYeni);
  // SEÇİLİ HASTA sol panelde durur ve hücreden hücreye geçerken KAYBOLMAZ — VB6'daki gibi
  // önce hasta seçilir, sonra ızgarada saate tıklanır (kullanıcı talebi: 2026-09-05).
  const [hasta, setHasta] = useState(null);
  // Sol paneldeki sekme: 'kimlik' | 'adres' | 'tercihler' (VB6'daki üç sekmenin karşılığı).
  const [sekme, setSekme] = useState('kimlik');
  // TERCİHLER sekmesi: eklenebilecek uzmanlar ve seçim.
  const [tercihUzmanlari, setTercihUzmanlari] = useState([]);
  const [tercihSecim, setTercihSecim] = useState('');
  const [aramaMetni, setAramaMetni] = useState('');
  const [aramaSonuc, setAramaSonuc] = useState([]);
  const [telAramaMetni, setTelAramaMetni] = useState('');   // telefonla arama (2026-09-21)
  const [kuralHatalari, setKuralHatalari] = useState(null);
  const [detay, setDetay] = useState(null);
  const [islemde, setIslemde] = useState(false);
  const [silOnay, setSilOnay] = useState(false);
  // Randevu SMS'leri (VB6 'Yeniden SMS' ve 'Randevu İptali' pencereleri).
  const [smsBilgi, setSmsBilgi] = useState(null);
  const [iptalSms, setIptalSms] = useState(false);
  const [iptalMetni, setIptalMetni] = useState('');
  const [yenidenAcik, setYenidenAcik] = useState(false);
  const [yenidenMetni, setYenidenMetni] = useState('');
  const [kapatma, setKapatma] = useState({ dkSay: 1, aciklama: '' });

  // Randevu Ver penceresindeki hak tablosu (VB6 "Satış Planlamadan Doğan Hakları").
  // Seçili hastanın KULLANILMAMIŞ hakları: randevu penceresindeki sade liste ve HAKLAR (n) sayısı.
  const [hakVeri, setHakVeri] = useState({ kullanilmamis: 0, kullanilmis: 0, haklar: [] });
  // HAKLAR penceresi: null | { baslangic: 'liste' | 'yeni', gun, randevudan }.
  const [haklarPencere, setHaklarPencere] = useState(null);
  // Seçilen hakka göre sunucunun hazırladıkları: hizmet süresi, boş odalar, SMS metinleri.
  const [hazirlik, setHazirlik] = useState(null);
  // Hızlı Hasta Kaydı penceresi: 'yeni' | 'duzenle' | null (VB6 SSPanel4).
  const [hastaPencere, setHastaPencere] = useState(null);
  // Hastanın Tüm Randevuları penceresi ve oradan "git" denince ızgarada ortalanacak hücre.
  const [randevularAcik, setRandevularAcik] = useState(false);
  const [odak, setOdak] = useState(null);           // { anahtar: 'yyyy-mm-dd|HH:mm', zaman }
  const [odakHucre, setOdakHucre] = useState('');   // kısa süre vurgulanan hücre
  // Kesilen (taşınmayı bekleyen) randevu ve taşıma penceresinin durumu.
  const [kesilen, setKesilen] = useState(null);     // { id, adSoy, tarih, saat, doktor }
  const [tasima, setTasima] = useState(null);       // { h, notRandevu, oda, sms, smsMetni, yukleniyor }  // Çizelge + renk açıklaması alanı — Yeni Randevu penceresi tam bu alanın üstünde açılır.
  const cizelgeRef = useRef(null);
  // Izgara yüksekliği: ekranın altına kadar (renk açıklaması en altta), TAM SATIR sayısına
  // yuvarlanmış — son satır yarım görünmesin (kullanıcı talebi: 2026-09-19).
  const izgaraRef = useRef(null);
  const lejantRef = useRef(null);
  const [izgaraYukseklik, setIzgaraYukseklik] = useState(null);

  // Durum mesajları kısa süre görünür, sonra kutu boşalır (bilgi 6 sn, hata 12 sn).
  useEffect(() => {
    if (!bilgi) return undefined;
    const z = setTimeout(() => setBilgi(''), 6000);
    return () => clearTimeout(z);
  }, [bilgi]);
  useEffect(() => {
    if (!hata) return undefined;
    const z = setTimeout(() => setHata(''), 12000);
    return () => clearTimeout(z);
  }, [hata]);

  useEffect(() => {
    api.get('/RandevuEkrani/secenekler')
      .then(({ data }) => setSecenek(data))
      .catch(err => setHata(err.response?.data?.hata || 'Seçenekler alınamadı.'));
  }, []);

  // Uygun Randevu Bulucu'dan "HEDEFE GİT" ile gelindiyse o uzman, tarih ve saatte açılır
  // (VB6 YOL_GOSTERICI_1 → RANDEVUFORM "Hedefe Git" akışının karşılığı, 2026-09-21).
  useEffect(() => {
    let hedef = null;
    try {
      const ham = localStorage.getItem('randevuHedefi');
      if (ham) { hedef = JSON.parse(ham); localStorage.removeItem('randevuHedefi'); }
    } catch { hedef = null; }
    // Eski bir hedef yanlışlıkla uygulanmasın: 2 dakikadan eskisi yok sayılır.
    if (!hedef?.dokKod || !hedef.tarih || Date.now() - (hedef.zaman || 0) > 120000) return;
    setKapsam('hepsi');
    setDokKod(String(hedef.dokKod));
    setTarih(hedef.tarih);
    if (hedef.saat) setOdak({ anahtar: `${hedef.tarih}|${hedef.saat}`, zaman: Date.now() });
    setBilgi(`${hedef.uzman || 'Uzman'} · ${hedef.tarih} ${hedef.saat || ''} hedefine gidildi.`);
  }, []);

  useEffect(() => {
    api.get('/RandevuEkrani/uzmanlar', { params: { kapsam } })
      .then(({ data }) => {
        setUzmanlar(data);
        setDokKod(k => (data.some(u => String(u.kod) === String(k)) ? k : (data[0]?.kod ?? '')));
      })
      .catch(err => setHata(err.response?.data?.hata || 'Uzman listesi alınamadı.'));
  }, [kapsam]);

  const yukle = useCallback(async () => {
    if (!dokKod) { setHafta(null); return; }
    setYukleniyor(true); setHata('');
    try {
      const { data } = await api.get('/RandevuEkrani/hafta', { params: { dokKod, tarih } });
      setHafta(data);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Randevu ızgarası alınamadı.');
      setHafta(null);
    } finally {
      setYukleniyor(false);
    }
  }, [dokKod, tarih]);

  useEffect(() => { yukle(); }, [yukle]);

  useLayoutEffect(() => {
    const olc = () => {
      const kutu = izgaraRef.current;
      // Dar ekranda (tek sütun düzen) CSS'teki varsayılan kalır.
      if (!kutu || window.innerWidth <= 1000) { setIzgaraYukseklik(null); return; }
      const bas = kutu.querySelector('thead')?.getBoundingClientRect().height ?? 0;
      const satir = kutu.querySelector('tbody tr')?.getBoundingClientRect().height ?? 0;
      if (!satir) return;
      const kenar = kutu.offsetHeight - kutu.clientHeight;
      const lejant = (lejantRef.current?.offsetHeight ?? 0) + 8;   // + margin-top
      const ust = kutu.getBoundingClientRect().top + window.scrollY;
      const alan = window.innerHeight - ust - lejant - 14;          // 14: alt boşluk
      const satirSayisi = Math.max(8, Math.floor((alan - bas - kenar) / satir));
      const tumu = kutu.querySelectorAll('tbody tr').length;
      setIzgaraYukseklik(Math.ceil(bas + Math.min(satirSayisi, tumu) * satir + kenar));
    };
    olc();
    window.addEventListener('resize', olc);
    return () => window.removeEventListener('resize', olc);
  }, [hafta, kesilen]);

  // "Git" ile gelinen randevunun hücresi ızgara yüklenince ortaya kaydırılır ve kısa süre
  // vurgulanır. 15 sn içinde bulunamazsa (saat bu uzmanın ızgarasında yoksa) vazgeçilir.
  useEffect(() => {
    if (!odak || !hafta) return undefined;
    if (Date.now() - odak.zaman > 15000) { setOdak(null); return undefined; }
    const el = document.querySelector(`[data-hucre="${odak.anahtar}"]`);
    if (!el) return undefined;
    el.scrollIntoView({ block: 'center', inline: 'nearest' });
    setOdakHucre(odak.anahtar);
    setOdak(null);
    const z = setTimeout(() => setOdakHucre(''), 3000);
    return () => clearTimeout(z);
  }, [hafta, odak]);

  const hakListesiYukle = useCallback(async (kayitNo, durum) => {
    try {
      const { data } = await api.get('/RandevuEkrani/hak-listesi', { params: { kayitNo, durum } });
      setHakVeri(data);
      return data;
    } catch (err) {
      setModalHata(err.response?.data?.hata || 'Satış hakları alınamadı.');
      return null;
    }
  }, []);

  // Hasta BİLEREK korunuyor: aynı hastaya arka arkaya birkaç randevu vermek sık yapılan bir
  // iş, her seferinde yeniden aratmak gereksiz.
  const pencereyiKapat = () => {
    setModal(null); setSecili(null); setYeni(bosYeni); setModalHata('');
    setKuralHatalari(null); setDetay(null);
    setSilOnay(false); setKapatma({ dkSay: 1, aciklama: '' });
    setSmsBilgi(null); setYenidenAcik(false); setIptalSms(false);
    setTasima(null);
  };

  const haftaKaydir = (yon) => {
    const [y, a, g] = tarih.split('-').map(Number);
    const d = new Date(y, a - 1, g + yon * 7);
    setTarih(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`);
    pencereyiKapat();
  };

  // Hak seçilince (VB6 Command21): süre hizmetin gerektirdiği dakikaya KENDİLİĞİNDEN ayarlanır
  // (kullanıcı: "bize iş bırakmamalı"), ilk boş oda seçilir, SMS seçenekleri ve metinleri gelir.
  const hakSec = async (id, h = secili) => {
    setYeni(y => ({ ...y, planlamaId: id }));
    setHazirlik(null);
    setKuralHatalari(null);
    if (!h || !hasta) return;
    try {
      const { data } = await api.get('/RandevuEkrani/hazirlik', {
        params: { dokKod, tarih: h.tarih, saat: h.saat, kayitNo: hasta.kayitNo, planlamaId: id },
      });
      setHazirlik(data);
      const bos = musaitPeriyot(hafta, h.satir, h.sutun);
      setYeni(y => ({
        ...y,
        dkSay: y.notRandevu ? y.dkSay : Math.min(Math.max(data.onerilenDkSay || 1, 1), bos),
        odaAdi: data.odaGerekli ? (data.bosOdalar[0] ?? '') : '',
        hastayaSms: data.hastaSmsAcik,
        hastaSmsMetni: data.hastaSmsMetni,
        hnSms: data.hnSmsAcik,
      }));
    } catch (err) {
      setModalHata(err.response?.data?.hata || 'Randevu bilgileri hazırlanamadı.');
    }
  };

  const hucreSec = async (r, s, h, saat, gunTarihi) => {    setHata(''); setBilgi(''); setModalHata(''); setKuralHatalari(null); setSilOnay(false);

    if (h.randId) {
      setSecili({ satir: r, sutun: s, hucre: h, saat, tarih: gunTarihi });
      setDetay(null);
      setModal('detay');
      try {
        const { data } = await api.get(`/RandevuEkrani/randevu/${h.randId}`);
        setDetay(data);
        // HEDEFİ SEÇ (VB6 çift tıklama) — web'de tek tıkla: randevunun hastası sol panelde,
        // elle aranıp seçilmiş gibi açılır; ayrı buton gerekmez (kullanıcı kararı: 2026-09-19).
        if (data.tur !== 0 && data.kayitNo > 0 && hasta?.kayitNo !== data.kayitNo) {
          hastayiGetir(data.kayitNo, data.adSoy);
        }
        setSmsBilgi(null); setYenidenAcik(false);
        if (data.tur !== 0) {
          const { data: b } = await api.get(`/RandevuEkrani/${h.randId}/sms-bilgi`);
          setSmsBilgi(b);
          // VB6: iptal SMS'i varsayılan 'Gönderilsin'.
          setIptalSms(b.iptalAcik);
          setIptalMetni(b.iptalMetni || '');
          setYenidenMetni(b.yenidenMetni || '');
        }
      } catch (err) {
        setModalHata(err.response?.data?.hata || 'Randevu detayı alınamadı.');
      }
      return;
    }

    if (YAZILAMAZ.includes(h.durum)) return;
    setSecili({ satir: r, sutun: s, hucre: h, saat, tarih: gunTarihi });

    // KESİLMİŞ randevu varsa boş saate tıklamak onu buraya TAŞIMA penceresini açar (VB6 yapıştır).
    if (kesilen) {
      setModal('tasi');
      tasimaHazirla(notSaatiMi(saat), { saat, tarih: gunTarihi });
      return;
    }

    // VB6 davranışı: hasta seçiliyse RANDEVU VER, değilse SAAT KAPAMA.
    if (!hasta) {
      setKapatma({ dkSay: 1, aciklama: '' });
      setModal('kapat');
      return;
    }

    // Tarife VB6'daki gibi BOŞ başlar ("LÜTFEN TARİFE SEÇİNİZ"): seçilmeden randevu verilmez.
    // Not randevusu artık seçilmez, SAATTEN gelir (09:00–09:45) — kullanıcı kuralı: 2026-09-21.
    setYeni({ ...bosYeni, notRandevu: notSaatiMi(saat) });
    setHazirlik(null);
    setModal('yeni');
    // Hak BİLEREK otomatik seçilmez (kullanıcı talebi: 2026-09-20) — personel hizmeti kendisi seçmeli.
    await hakListesiYukle(hasta.kayitNo, 'kullanilmamis');
  };

  // Randevu penceresindeki kısayoldan yeni paket açılınca: HAKLAR penceresi kapanır, liste
  // yenilenir ve yeni paketin ilk hakkı seçilir — randevu hemen verilebilsin.
  const yeniHakKaydedildi = async (ortakMasterProtNo, mesaj) => {
    setHaklarPencere(null);
    setModalHata('');
    const veri = await hakListesiYukle(hasta.kayitNo, 'kullanilmamis');
    const ilk = veri?.haklar?.find(x => x.protokol === ortakMasterProtNo && !x.kullanildi);
    if (ilk && modal === 'yeni') hakSec(ilk.id);
    if (mesaj) setBilgi(mesaj);
  };

  // HAKLAR penceresinde bir değişiklik olunca (yeni paket / düzenleme / silme): sayı ve sade
  // liste yenilenir. Randevu penceresinde seçili hak silinmişse seçim sıfırlanır.
  const haklarDegisti = async (mesaj) => {
    if (!hasta) return;
    const veri = await hakListesiYukle(hasta.kayitNo, 'kullanilmamis');
    if (yeni.planlamaId && !veri?.haklar?.some(x => String(x.id) === String(yeni.planlamaId))) {
      setYeni(y => ({ ...y, planlamaId: '' }));
      setHazirlik(null);
    }
    if (mesaj) setBilgi(mesaj);
  };

  const hastaAra = async () => {
    if (aramaMetni.trim().length < 3) { setHata('En az 3 harf yazın.'); return; }
    setHata('');
    try {
      const { data } = await api.get('/RandevuEkrani/hasta-ara', { params: { arama: aramaMetni } });
      setAramaSonuc(data);
      if (data.length === 0) setBilgi('Bu isimde hasta bulunamadı.');
    } catch (err) {
      setHata(err.response?.data?.hata || 'Hasta araması yapılamadı.');
    }
  };

  // Telefonla hasta arama (kullanıcı talebi: 2026-09-21) — cep ya da sabit numara.
  const telefonAra = async () => {
    const rakam = telAramaMetni.replace(/\D/g, '');
    if (rakam.length < 4) { setHata('En az 4 rakam yazın.'); return; }
    setHata('');
    try {
      const { data } = await api.get('/RandevuEkrani/hasta-ara', { params: { tel: telAramaMetni } });
      setAramaSonuc(data);
      if (data.length === 0) setBilgi('Bu telefonla hasta bulunamadı.');
    } catch (err) {
      setHata(err.response?.data?.hata || 'Hasta araması yapılamadı.');
    }
  };

  const hastaSec = async (h) => {
    setHasta(h);
    setBilgi(''); setHata(''); setSekme('kimlik');
    setHakVeri({ kullanilmamis: 0, kullanilmis: 0, haklar: [] });
    hakListesiYukle(h.kayitNo, 'kullanilmamis');   // HAKLAR (n) sayısı için
    try {
      // Adres ve hoca tercihleri arama listesinde yok; hasta seçilince ayrıca alınıyor.
      const { data: tam } = await api.get(`/RandevuEkrani/hasta/${h.kayitNo}`);
      setHasta(tam);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Hasta bilgileri alınamadı.');
    }
  };

  // --- HOCA TERCİHLERİ (VB6 Command67 / Command65) ---
  useEffect(() => {
    if (sekme !== 'tercihler' || tercihUzmanlari.length > 0) return;
    api.get('/RandevuEkrani/tercih-uzmanlari').then(({ data }) => setTercihUzmanlari(data)).catch(() => {});
  }, [sekme, tercihUzmanlari.length]);

  const tercihleriYenile = async () => {
    const { data } = await api.get(`/RandevuEkrani/hasta/${hasta.kayitNo}`);
    setHasta(data);
  };

  const tercihEkle = async () => {
    const u = tercihUzmanlari.find(x => String(x.kod) === String(tercihSecim));
    if (!u || !window.confirm(`${u.adi} isimli hoca bu hastanın tercih listesine eklensin mi?`)) return;
    try {
      const { data } = await api.post(`/RandevuEkrani/hasta/${hasta.kayitNo}/tercih`, { dokKod: u.kod });
      setTercihSecim('');
      await tercihleriYenile();
      setBilgi(data.mesaj);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Hoca tercihi eklenemedi.');
    }
  };

  const tercihSil = async (t) => {
    if (!window.confirm(`${t.doktor} isimli hoca bu hastanın tercih listesinden çıkarılsın mı?`)) return;
    try {
      const { data } = await api.delete(`/RandevuEkrani/hasta/${hasta.kayitNo}/tercih/${t.dokKod}`);
      await tercihleriYenile();
      setBilgi(data.mesaj);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Hoca tercihi silinemedi.');
    }
  };

  const hastayiBirak = () => {
    setHasta(null); setSekme('kimlik');
  };

  // Kayıt/güncelleme sonrası VB6'daki gibi hasta adıyla arama yapılır; web'de ayrıca hasta
  // doğrudan seçilir — hemen randevu verilebilsin.
  const hastayiGetir = async (kayitNo, adi) => {
    const ad = (adi || '').trim();
    setAramaMetni(ad);
    try {
      const { data } = await api.get('/RandevuEkrani/hasta-ara', { params: { arama: ad } });
      setAramaSonuc(data);
    } catch { /* arama listesi yenilenemese de hasta seçilir */ }
    await hastaSec({ kayitNo, adi: ad });
  };

  // --- KES / YAPIŞTIR (VB6 Command10 / Command4 / Command24) ---
  // Kural: taşıma = yeni randevu verme kuralları. Pencere açılınca ve seçenek değişince
  // sunucu kuralları denetler; ihlal varsa TAŞI butonu kapalıdır, sunucu da ayrıca reddeder.
  const randevuyuKes = () => {
    setKesilen({ id: detay.id, adSoy: detay.adSoy, tarih: detay.tarih, saat: detay.saat, doktor: detay.doktor });
    pencereyiKapat();
    setBilgi('Randevu kesildi — taşımak istediğiniz uzmanın boş saatine tıklayın.');
  };

  const tasimaHazirla = async (notRandevu, yer = secili) => {
    setModalHata('');
    setTasima(t => ({ ...(t || {}), yukleniyor: true, notRandevu }));
    try {
      const { data } = await api.get(`/RandevuEkrani/${kesilen.id}/tasima-hazirlik`, {
        params: { dokKod, tarih: yer.tarih, saat: yer.saat, notRandevu },
      });
      setTasima({
        // Not randevusu kararını sunucu hedef saate göre verir (09:00–09:45).
        h: data, notRandevu: data.notRandevu ?? notRandevu, yukleniyor: false,
        oda: data.bosOdalar.includes(data.mevcutOda) ? data.mevcutOda : (data.bosOdalar[0] ?? ''),
        sms: data.smsAcik, smsMetni: data.smsMetni,
      });
    } catch (err) {
      setTasima(null);
      setModalHata(err.response?.data?.hata || 'Taşıma bilgileri alınamadı.');
    }
  };

  const tasimaYap = async () => {
    setModalHata(''); setIslemde(true);
    try {
      const { data } = await api.post(`/RandevuEkrani/${kesilen.id}/tasi`, {
        dokKod: Number(dokKod), tarih: secili.tarih, saat: secili.saat, notRandevu: tasima.notRandevu,
        odaAdi: tasima.oda, sms: tasima.sms, smsMetni: tasima.smsMetni,
      });
      setKesilen(null);
      setBilgi([data.mesaj, data.sms].filter(Boolean).join(' · '));
      pencereyiKapat();
      yukle();
    } catch (err) {
      setModalHata(err.response?.data?.hata || 'Randevu taşınamadı.');
    } finally {
      setIslemde(false);
    }
  };

  // VB6 Grid1_DblClick: randevunun uzmanı ve haftası açılır, saat ızgarada ortalanır.
  const randevuyaGit = (r) => {
    setRandevularAcik(false);
    pencereyiKapat();
    const kod = String(r.dokKod);
    if (!uzmanlar.some(u => String(u.kod) === kod)) setKapsam('hepsi');
    setDokKod(kod);
    const gun = String(r.tarih).slice(0, 10);
    setTarih(gun);
    setOdak({ anahtar: `${gun}|${r.saat}`, zaman: Date.now() });
  };

  const hastaKaydedildi = async (kayitNo, adi, mesaj) => {
    const duzenlendi = hastaPencere === 'duzenle';
    setHastaPencere(null);
    await hastayiGetir(kayitNo, adi);
    setBilgi(mesaj);
    if (duzenlendi) yukle();   // ızgaradaki isimler de güncellensin
  };
  const istekNesnesi = () => ({
    dokKod: Number(dokKod),
    tarih: secili.tarih,
    saat: secili.saat,
    kayitNo: hasta?.kayitNo ?? 0,
    planlamaId: Number(yeni.planlamaId) || 0,
    tarifeKod: Number(yeni.tarifeKod) || 0,
    dkSay: Number(yeni.dkSay) || 1,
    notRandevu: yeni.notRandevu,
    aciklama: yeni.aciklama,
    ozelIstekKod: Number(yeni.ozelIstekKod) || 0,
    ozelIstekAdi: secenek?.ozelIstekler?.find(o => o.kod === Number(yeni.ozelIstekKod))?.adi ?? '',
    odaAdi: yeni.odaAdi,
    provizyonNo: yeni.provizyonNo,
    hastayaSms: yeni.hastayaSms,
    hastaSmsMetni: yeni.hastaSmsMetni,
    hnSms: yeni.hnSms,
  });

  const kuralDenetimi = async () => {
    // Hak seçilmeden sunucuya sorulmaz: "HAK SEÇİLMEDEN..." maddesi zaten listede; sunucu da
    // aynı şeyi "Satış planlama kaydı bulunamadı" diye tekrar ediyordu (2026-09-20).
    if (!yeni.planlamaId) { setKuralHatalari(null); return; }
    setModalHata(''); setIslemde(true);
    try {
      const { data } = await api.post('/RandevuEkrani/kural-denetimi', istekNesnesi());
      setKuralHatalari(data.uygun ? [] : data.hatalar);
    } catch (err) {
      setModalHata(err.response?.data?.hata || 'Kural denetimi yapılamadı.');
    } finally {
      setIslemde(false);
    }
  };

  const randevuVer = async () => {
    setModalHata(''); setIslemde(true);
    try {
      const { data } = await api.post('/RandevuEkrani', istekNesnesi());
      setBilgi([`Randevu kaydedildi. Protokol no: ${data.masterProtNo}`, ...(data.sms ?? [])].join(' · '));
      if (hasta) hakListesiYukle(hasta.kayitNo, 'kullanilmamis');   // HAKLAR (n) güncellensin
      pencereyiKapat();
      yukle();
    } catch (err) {
      setModalHata(err.response?.data?.hata || 'Randevu kaydedilemedi.');
    } finally {
      setIslemde(false);
    }
  };

  const randevuGuncelle = async () => {
    setModalHata(''); setIslemde(true);
    try {
      await api.put(`/RandevuEkrani/${detay.id}`, {
        ozelIstekKod: detay.ozelIstekKod,
        ozelIstekAdi: secenek?.ozelIstekler?.find(o => o.kod === Number(detay.ozelIstekKod))?.adi ?? '',
        aciklama: detay.aciklama,
        dkSay: Number(detay.dkSay) || 1,
      });
      setBilgi('Randevu güncellendi.');
      pencereyiKapat();
      yukle();
    } catch (err) {
      setModalHata(err.response?.data?.hata || 'Randevu güncellenemedi.');
    } finally {
      setIslemde(false);
    }
  };

  const randevuSil = async () => {
    setModalHata(''); setIslemde(true);
    try {
      if (detay.tur === 0) {
        await api.delete(`/RandevuEkrani/${detay.id}`);
        setBilgi('Kapalı saat açıldı.');
      } else {
        const { data } = await api.post(`/RandevuEkrani/${detay.id}/iptal`, { iptalSms, iptalSmsMetni: iptalMetni });
        setBilgi(['Randevu iptal edildi, satış hakkı serbest bırakıldı.', data.sms].filter(Boolean).join(' · '));
        if (hasta) hakListesiYukle(hasta.kayitNo, 'kullanilmamis');
      }
      pencereyiKapat();
      yukle();
    } catch (err) {
      setModalHata(err.response?.data?.hata || 'Randevu iptal edilemedi.');
      setSilOnay(false);
    } finally {
      setIslemde(false);
    }
  };

  const saatKapat = async () => {
    setModalHata(''); setIslemde(true);
    try {
      await api.post('/RandevuEkrani/saat-kapat', {
        dokKod: Number(dokKod),
        tarih: secili.tarih,
        saat: secili.saat,
        dkSay: Number(kapatma.dkSay) || 1,
        aciklama: kapatma.aciklama,
      });
      setBilgi('Saat kapatıldı.');
      pencereyiKapat();
      yukle();
    } catch (err) {
      setModalHata(err.response?.data?.hata || 'Saat kapatılamadı.');
    } finally {
      setIslemde(false);
    }
  };

  const uzman = hafta?.uzman;
  const periyot = uzman?.periyotDakika ?? 15;

  // Boş hücre için: seçilen saatten aşağıya kaç periyot boş.
  const musait = secili ? musaitPeriyot(hafta, secili.satir, secili.sutun) : 1;
  // Mevcut randevu için: kendi satırları da boş sayılır (süre kısaltılıp uzatılabilsin).
  const musaitDetay = (secili && detay) ? musaitPeriyot(hafta, secili.satir, secili.sutun, detay.id) : 1;

  const seciliTarife = secenek?.tarifeler?.find(t => String(t.kod) === String(yeni.tarifeKod));

  // Randevu penceresindeki sade liste: yalnızca kullanılmamış haklar ve seçilebilir olanlar.
  // Hizmete göre tekil seçenekler: her hizmet için en eski (en küçük numaralı) sırası gelen hak.
  const siradakiHakIdleri = siradakiler(hakVeri.haklar);
  // Pencerenin sağındaki salt-seçim listesi (kullanıcı talebi: 2026-09-22).
  const kullanilmamisHaklar = hakVeri.haklar.filter(h => !h.kullanildi);

  // Tarife seçilmemişse bu da kural listesinde, aynı biçimde görünür (kullanıcı talebi: 2026-09-19).
  // Not randevusunda hak ve tarife aranmaz (kullanıcı kuralı: 2026-09-21).
  const tumHatalar = yeni.notRandevu ? (kuralHatalari ?? []) : [
    ...(!yeni.planlamaId ? ['HAK SEÇİLMEDEN randevu verilemez — hangi hizmetten randevu verileceğini seçiniz.'] : []),
    // Hak seçilmemiş olsa da tarife eksikliği aynı anda gösterilir (kullanıcı talebi: 2026-09-20).
    ...(!yeni.tarifeKod ? ['UYGULANACAK TARİFEYİ belirlemeden randevu verilemez.'] : []),
    ...(kuralHatalari ?? []),
  ];

  const sureSecenekleri = (adet) => Array.from({ length: adet }, (_, i) => i + 1);

  return (
    <div className="re">

      <div className="re-duzen">
        {/* ============================ SOL SÜTUN: uzman + hasta ============================ */}
        <aside className="re-sol">
          <div className="card re-kutu">
            <strong className="re-baslik">UZMAN</strong>
            <div className="re-kapsam" role="radiogroup">
              {[['daimi', 'Daimi'], ['part', 'Part Time'], ['hepsi', 'Tümü']].map(([v, ad]) => (
                <label key={v} className={kapsam === v ? 'secili' : ''}>
                  <input type="radio" name="re-kapsam" checked={kapsam === v}
                         onChange={() => { setKapsam(v); pencereyiKapat(); }} />
                  {ad}
                </label>
              ))}
            </div>
            <select className="re-uzman" value={dokKod} onChange={e => { setDokKod(e.target.value); pencereyiKapat(); }}>
              {uzmanlar.length === 0 && <option value="">(uzman yok)</option>}
              {uzmanlar.map(u => (
                <option key={u.kod} value={u.kod}>{u.adi}</option>
              ))}
            </select>
          </div>

          <div className="card re-kutu">
            <strong className="re-baslik">HASTA SEÇİNİZ</strong>
            <div className="re-arama">
              <input value={aramaMetni} onChange={e => setAramaMetni(e.target.value)}
                     onKeyDown={e => e.key === 'Enter' && hastaAra()}
                     placeholder="Ad soyad (en az 3 harf)" />
              <button className="btn btn-secondary" onClick={hastaAra}>Ara</button>
            </div>
            {/* Telefonla arama (kullanıcı talebi: 2026-09-21). Numaralar kartta maskeli
                duruyor; sunucu tireleri atıp rakam bazlı arıyor, baştaki 0/+90 önemsizdir. */}
            <div className="re-arama">
              <input value={telAramaMetni} onChange={e => setTelAramaMetni(e.target.value)}
                     onKeyDown={e => e.key === 'Enter' && telefonAra()}
                     placeholder="Telefon (en az 4 rakam)" inputMode="numeric" />
              <button className="btn btn-secondary" onClick={telefonAra}>Ara</button>
            </div>

            {/* VB6'daki "Hasta Adı Soyadı" listesi: arama sonucu yerinde kalır, seçilen satır
                işaretli görünür — başka hastaya geçmek için yeniden aratmak gerekmez. */}
            {/* SABİT YERLEŞİM (kullanıcı talebi: 2026-09-20): liste kutusu, kimlik kartı ve alttaki
                butonlar hasta sayısından / seçimden bağımsız HEP AYNI yerde ve boyutta durur. */}
            <ul className="re-sonuc">
              {aramaSonuc.length === 0 && (
                <li className="re-sonuc-bos">
                  Hasta seçip boş bir saate tıklayınca <b>randevu</b> penceresi açılır. Hasta
                  seçili değilken boş saate tıklamak <b>saat kapama</b> penceresini açar.
                </li>
              )}
              {aramaSonuc.map(h => (
                <li key={h.kayitNo} onClick={() => hastaSec(h)}
                    className={hasta?.kayitNo === h.kayitNo ? 'secili' : ''}>
                  <strong>{h.adi}</strong>
                  <span>{h.cepTel}</span>
                </li>
              ))}
            </ul>

            <div className="re-kimlik-bas">
              <strong>{hasta ? hasta.adi : 'Hasta seçilmedi'}</strong>
              <button className="btn btn-secondary" onClick={hastayiBirak} disabled={!hasta}>SEÇİMİ BIRAK</button>
            </div>

            {!hasta ? (
              <>
                <div className="re-sekmeler">
                  {['KİMLİK', 'ADRES', 'TERCİHLER'].map(ad => <button key={ad} className="re-sekme" disabled>{ad}</button>)}
                </div>
                <div className="re-sekme-govde re-sekme-bos">Hasta bilgileri burada görünür.</div>
              </>
            ) : (
              <>

                {/* VB6'daki KİMLİK / ADRES / TERCİHLER sekmeleri (kullanıcı talebi: 2026-09-06) */}
                <div className="re-sekmeler">
                  {[['kimlik', 'KİMLİK'], ['adres', 'ADRES'], ['tercihler', 'TERCİHLER']].map(([k, ad]) => (
                    <button key={k} className={`re-sekme${sekme === k ? ' aktif' : ''}`} onClick={() => setSekme(k)}>
                      {ad}
                    </button>
                  ))}
                </div>

                <div className="re-sekme-govde">
                  {sekme === 'kimlik' && (
                    <div className="re-alanlar">
                      <div><span>Kimlik No</span><b>{hasta.tcKimlik || '—'}</b></div>
                      <div><span>Adı - Soyadı</span><b>{hasta.adi}</b></div>
                      <div><span>D.Tar / Cins</span><b>{trTarih(hasta.dogTar) || '—'}{hasta.cins ? ` · ${hasta.cins}` : ''}</b></div>
                      <div><span>Cep Telefonu</span><b>{hasta.cepTel || '—'}</b></div>
                      <div><span>Diğer Telefonu</span><b>{hasta.digerTel || '—'}</b></div>
                    </div>
                  )}

                  {sekme === 'adres' && <p className="re-adres">{hasta.adres || 'Adres kaydı yok.'}</p>}

                  {sekme === 'tercihler' && (
                    <>
                      <strong className="re-alt-baslik">Hoca Tercihleri</strong>
                      {(hasta.tercihler ?? []).length === 0 && <p className="re-bos-not">Hoca tercihi yok.</p>}
                      {(hasta.tercihler ?? []).length > 0 && (
                        <ul className="re-tercih-liste">
                          {hasta.tercihler.map(t => (
                            <li key={t.dokKod}>
                              <span>{t.doktor}</span>
                              <button className="re-tercih-sil" onClick={() => tercihSil(t)} title="Tercih listesinden çıkar">✕</button>
                            </li>
                          ))}
                        </ul>
                      )}
                      {/* VB6 SSPanel27: hoca tercihi ekleme (kullanıcı bildirimi: 2026-09-20). */}
                      <div className="re-tercih-ekle">
                        <select value={tercihSecim} onChange={e => setTercihSecim(e.target.value)}>
                          <option value="">Hoca seçiniz...</option>
                          {tercihUzmanlari
                            .filter(u => !(hasta.tercihler ?? []).some(t => t.dokKod === u.kod))
                            .map(u => <option key={u.kod} value={u.kod}>{u.adi}</option>)}
                        </select>
                        <button className="btn btn-primary" onClick={tercihEkle} disabled={!tercihSecim}>Ekle</button>
                      </div>
                      <div className="re-cins-tercih">
                        {hasta.cinsTercih === 1 ? 'Hoca Cinsiyet Tercihi: KADIN'
                          : hasta.cinsTercih === 2 ? 'Hoca Cinsiyet Tercihi: ERKEK'
                          : 'Hoca Cinsiyet Tercihi Yok'}
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
          </div>

          {/* VB6 sol alt köşedeki iki buton: Yeni Hasta Kaydı ve seçili hastanın kimlik güncellemesi. */}
          {/* Dört buton aynı yapıda, her biri kendi pastel renginde; pasifken gri
              (kullanıcı talebi: 2026-09-20). */}
          <div className="re-hasta-dugmeler">
            <button className="re-hd re-hd-yeni" onClick={() => setHastaPencere('yeni')}>
              <i>➕</i><span>Yeni Hasta Kaydı</span>
            </button>
            <button className="re-hd re-hd-guncelle" onClick={() => setHastaPencere('duzenle')} disabled={!hasta}
                    title={hasta ? 'Seçili hastanın kimlik bilgilerini güncelle' : 'Önce hasta seçin'}>
              <i>✎</i><span>Hasta Bilgilerini Güncelle</span>
            </button>
            <button className="re-hd re-hd-randevular" onClick={() => setRandevularAcik(true)} disabled={!hasta}
                    title={hasta ? 'Seçili hastanın tüm randevuları' : 'Önce hasta seçin'}>
              <i>📅</i><span>Hastanın Randevuları</span>
            </button>
            {/* HAKLAR (kullanıcı talebi: 2026-09-20): hastanın tüm hak işlemleri — randevu
                vermeden de erişilebilsin. Sayı = kullanılmamış hak. */}
            <button className="re-hd re-hd-haklar" onClick={() => setHaklarPencere({ baslangic: 'liste', gun: bugunIso() })}
                    disabled={!hasta} title={hasta ? 'Satış planlamadan doğan haklar' : 'Önce hasta seçin'}>
              <i>🎫</i><span>HAKLAR{hasta ? ` (${hakVeri.kullanilmamis})` : ''}</span>
            </button>
          </div>
        </aside>

        {/* ============================ ORTA: 7 günlük çizelge ============================ */}
        <section className="re-orta">
          <div className="re-serit">
            <h2 className="re-sayfa-baslik">🗓️ Randevu Ekranı{uzman ? <span> · {uzman.adi}</span> : null}</h2>
            {/* Durum kutusu HEP YERİNDE durur (boşken de) — mesaj gelince sayfa kaymaz, yazı birkaç
                saniye sonra kendiliğinden silinir (kullanıcı talebi: 2026-09-19). */}
            <div className={`re-durum${hata ? ' hata' : bilgi ? ' bilgi' : ''}`} role="status" aria-live="polite"
                 title={hata || bilgi || ''}>
              {hata || bilgi}
            </div>
            <div className="re-gezinti">
              {/* Sıra (kullanıcı talebi: 2026-09-20): Yenile · Önceki · Bu hafta · Sonraki · tarih. */}
              <button className="btn btn-secondary re-yenile" title="Izgarayı yenile (F5 gerekmez)"
                      onClick={() => { pencereyiKapat(); yukle(); if (hasta) hakListesiYukle(hasta.kayitNo, 'kullanilmamis'); }}>
                ⟳ YENİLE
              </button>
              <button className="btn btn-secondary" onClick={() => haftaKaydir(-1)}>‹ ÖNCEKİ HAFTA</button>
              {/* Aynı haftadayken de ızgarayı tazeler. */}
              <button className="btn btn-secondary" onClick={() => { setTarih(bugunIso()); pencereyiKapat(); yukle(); }}>BU HAFTA</button>
              <button className="btn btn-secondary" onClick={() => haftaKaydir(1)}>SONRAKİ HAFTA ›</button>
              <input type="date" value={tarih} onChange={e => { setTarih(e.target.value); pencereyiKapat(); }} />
            </div>
          </div>

          {kesilen && (
            <div className="re-kesilen">
              <span>✂ Kesilen randevu: <b>{kesilen.adSoy}</b> — {trTarih(kesilen.tarih)} {kesilen.saat} · {kesilen.doktor}.
                {' '}Taşımak için istediğiniz uzmanın <b>boş saatine</b> tıklayın.</span>
              <button className="btn btn-secondary" onClick={() => setKesilen(null)}>Vazgeç</button>
            </div>
          )}

          {yukleniyor && <div className="loading">Yükleniyor...</div>}

          {!yukleniyor && hafta && hafta.saatler.length === 0 && (
            <div className="empty">Bu uzmanın randevu saati tanımlı değil (RANDEVU_GUNLER). Izgara çizilemez.</div>
          )}

          {!yukleniyor && hafta && hafta.saatler.length > 0 && (
            <div ref={cizelgeRef} className="re-cizelge">
              <div ref={izgaraRef} className="card re-izgara-kutu"
                   style={izgaraYukseklik ? { maxHeight: izgaraYukseklik, minHeight: 0 } : undefined}>
                <table className="re-izgara">
                  <thead>
                    <tr>
                      <th className="re-saat-bas">SAAT</th>
                      {hafta.gunler.map((g, i) => (
                        <th key={g.tarih} className={g.tarih === bugunIso() ? 're-bugun' : ''}>
                          {kisaTarih(g.tarih)} {GUN_ADI[i]}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {hafta.saatler.map((saat, r) => (
                      <tr key={saat}>
                        <td className="re-saat">{saat}</td>
                        {hafta.hucreler[r].map((h, s) => {
                          const d = DURUM[h.durum] || DURUM.bos;
                          const sec = secili && secili.satir === r && secili.sutun === s;
                          return (
                            <td key={s}
                                data-hucre={`${String(hafta.gunler[s].tarih).slice(0, 10)}|${saat}`}
                                className={`re-hucre re-${h.durum}${sec ? ' re-secili' : ''}${odakHucre === `${String(hafta.gunler[s].tarih).slice(0, 10)}|${saat}` ? ' re-odak' : ''}${h.devam ? ' re-devam' : ''}${d.koyu ? ' re-koyu' : ''}${h.metin && h.aciklama?.trim() ? ' re-ack' : ''}${kesilen && h.randId === kesilen.id ? ' re-kesik' : ''}`}
                                style={{ background: d.renk }}
                                title={h.aciklama?.trim() || h.metin || d.ad}
                                onClick={() => hucreSec(r, s, h, saat, hafta.gunler[s].tarih)}>
                              {h.metin}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* VB6'daki renk açıklaması — çizelgenin hemen altında. */}
              <div ref={lejantRef} className="re-lejant">
                {LEJANT.map(([ad, renk]) => (
                  <span key={ad}><i style={{ background: renk }} />{ad}</span>
                ))}
              </div>
            </div>
          )}
        </section>
      </div>

      {/* ============================ MODAL: HIZLI HASTA KAYDI ============================ */}
      {hastaPencere && (
        <HastaKayitPenceresi mod={hastaPencere} hasta={hasta} gun={secili?.tarih ?? tarih}
                             kapat={() => setHastaPencere(null)} kaydedildi={hastaKaydedildi} />
      )}

      {randevularAcik && hasta && (
        <HastaRandevulariPenceresi hasta={hasta} kapat={() => setRandevularAcik(false)} git={randevuyaGit}
                                   tasindi={(m) => { setBilgi(m); yukle(); }} />
      )}

      {/* ============================ MODAL: RANDEVU VER ============================ */}
      {/* Hak listesi sağda geri geldi (kullanıcı talebi: 2026-09-22) — kullanıcılar hakkı kendileri
          görüp seçmek istiyor. Not randevusunda hak sorulmadığı için pencere dar ve tek sütun açılır. */}
      {modal === 'yeni' && secili && hasta && (
        <Pencere baslik="Yeni Randevu" genis={!yeni.notRandevu} hedefRef={yeni.notRandevu ? null : cizelgeRef}
                 kapat={pencereyiKapat}>
          <div className={`re-yr${yeni.notRandevu ? ' re-yr-sade' : ''}`}>
            <div className="re-yr-sol">
              <div className="re-tablo-form">
                <div><span>Adı Soyadı</span><b className="re-buyuk">{hasta.adi}</b></div>
                <div><span>Hasta No</span><b>{hasta.kayitNo}</b></div>
                <div><span>Telefon No</span><b>{hasta.cepTel || '—'}</b></div>
                <div>
                  <span>Giriş - Çıkış Saati</span>
                  <b>{secili.saat} – {saatEkle(secili.saat, (Number(yeni.dkSay) || 1) * periyot)}</b>
                </div>
                <div><span>Randevu Tarihi</span><b>{uzunTarih(secili.tarih)}</b></div>
                <div><span>Uzman</span><b>{uzman?.adi}</b></div>
                <div>
                  <span>Randevu Süresi</span>
                  {/* Not randevusunda süre sorulmaz: her zaman tek periyot (15 dk), böylece
                      09:00–09:45 arasına dört not sığar (kullanıcı kuralı: 2026-09-21). */}
                  {yeni.notRandevu
                    ? <b>{periyot} <small>dakika (not randevusu)</small></b>
                    : (
                      <b>
                        <select value={yeni.dkSay} onChange={e => setYeni(y => ({ ...y, dkSay: e.target.value }))}>
                          {sureSecenekleri(musait).map(n => <option key={n} value={n}>{n * periyot}</option>)}
                        </select>
                        {/* Süre hak seçilince hizmetin gerektirdiği dakikaya kendiliğinden ayarlanır;
                            yalnızca saatin altında o kadar boş yer YOKSA tek satır uyarı çıkar. */}
                        {hazirlik?.hizmetDakika > musait * periyot
                          ? <small className="re-sure-uyari">hizmet {hazirlik.hizmetDakika} dk ister, burada {musait * periyot} dk boş</small>
                          : <small>dakika</small>}
                      </b>
                    )}
                </div>
              </div>

              {/* NOT RANDEVUSU (kullanıcı kuralı: 2026-09-21): yalnızca 09:00–09:45 arası.
                  O saatlerde randevu koşulsuz not randevusudur ve kurallar işletilmez;
                  diğer saatlerde seçenek hiç gösterilmez. */}
              <div className="re-randevu-turu">
                {notSaatiMi(secili?.saat)
                  ? <label className="not secili"><span aria-hidden="true">📝</span>
                      Bu saat (09:00–09:45) NOT ALMA RANDEVUSUDUR</label>
                  : <label className="gercek secili">GERÇEK RANDEVU</label>}
              </div>

              <label className="re-etiket">Açıklama</label>
              <textarea rows={2} value={yeni.aciklama} onChange={e => setYeni(y => ({ ...y, aciklama: e.target.value }))} />

              {/* HAK SEÇİMİ artık YALNIZCA sağdaki listeden yapılır (kullanıcı talebi: 2026-09-22):
                  soldaki turuncu seçim kutusu ve ▶ ok düğmesi tamamen kaldırıldı, liste hep açık.
                  Not randevusunda hak (paket), tarife, oda, özel istek ve SMS SORULMAZ —
                  bu bir seans değil, ajandaya düşülen nottur (kullanıcı kuralı: 2026-09-21). */}

              {!yeni.notRandevu && (
              <fieldset className="re-randevu-ver">
                <legend>RANDEVU VER</legend>
                <div className="re-tablo-form">
                  <div>
                    <span>Tarife</span>
                    <b>
                      <select value={yeni.tarifeKod} onChange={e => setYeni(y => ({ ...y, tarifeKod: e.target.value }))}>
                        <option value="">LÜTFEN TARİFE SEÇİNİZ</option>
                        {(secenek?.tarifeler ?? []).map(t => <option key={t.kod} value={t.kod}>{t.adi}</option>)}
                      </select>
                    </b>
                  </div>
                  {seciliTarife?.sigorta === 1 && (
                    <div>
                      <span>Provizyon No</span>
                      <b><input value={yeni.provizyonNo} onChange={e => setYeni(y => ({ ...y, provizyonNo: e.target.value }))} /></b>
                    </div>
                  )}
                  <div>
                    <span>Özel İstek</span>
                    <b>
                      <select value={yeni.ozelIstekKod} onChange={e => setYeni(y => ({ ...y, ozelIstekKod: e.target.value }))}>
                        <option value={0}>YOK</option>
                        {(secenek?.ozelIstekler ?? []).map(o => <option key={o.kod} value={o.kod}>{o.adi}</option>)}
                      </select>
                    </b>
                  </div>

                  {/* HANGİ ODA — hizmet P/M odası istiyorsa (VB6 Combo15). Liste o saatte BOŞ
                      odalardır; boş oda yoksa randevu verilemez. */}
                  {hazirlik?.odaGerekli && (
                    <div>
                      <span>Hangi Oda</span>
                      <b>
                        {hazirlik.bosOdalar.length > 0 ? (
                          <select value={yeni.odaAdi} onChange={e => setYeni(y => ({ ...y, odaAdi: e.target.value }))}>
                            {hazirlik.bosOdalar.map(o => <option key={o} value={o}>{o}</option>)}
                          </select>
                        ) : (
                          <em className="re-oda-yok">Bu saatte BOŞ ODA yok — randevu verilemez</em>
                        )}
                      </b>
                    </div>
                  )}

                  <div>
                    <span>Hastaya SMS</span>
                    <b>
                      <label className="re-secim">
                        <input type="radio" checked={yeni.hastayaSms} disabled={!hazirlik?.hastaSmsAcik}
                               onChange={() => setYeni(y => ({ ...y, hastayaSms: true }))} /> Evet
                      </label>
                      <label className="re-secim">
                        <input type="radio" checked={!yeni.hastayaSms} disabled={!hazirlik?.hastaSmsAcik}
                               onChange={() => setYeni(y => ({ ...y, hastayaSms: false }))} /> Hayır
                      </label>
                      <small className="re-sms-not">
                        {hazirlik ? (hazirlik.hastaSmsAcik ? hazirlik.hastaTel : hazirlik.hastaSmsNeden) : ''}
                      </small>
                    </b>
                  </div>

                  <div>
                    <span>HN 'ye SMS</span>
                    <b>
                      <label className="re-secim">
                        <input type="radio" checked={yeni.hnSms} disabled={!hazirlik?.hnSmsAcik}
                               onChange={() => setYeni(y => ({ ...y, hnSms: true }))} /> Evet
                      </label>
                      <label className="re-secim">
                        <input type="radio" checked={!yeni.hnSms} disabled={!hazirlik?.hnSmsAcik}
                               onChange={() => setYeni(y => ({ ...y, hnSms: false }))} /> Hayır
                      </label>
                      {hazirlik && !hazirlik.hnSmsAcik && <small className="re-sms-not kirmizi">{hazirlik.hnSmsNeden}</small>}
                    </b>
                  </div>
                </div>

                {/* VB6'daki gibi hastaya gidecek SMS metni görünür ve düzenlenebilir. */}
                {yeni.hastayaSms && (
                  <textarea className="re-sms-metni" rows={3} value={yeni.hastaSmsMetni}
                            onChange={e => setYeni(y => ({ ...y, hastaSmsMetni: e.target.value }))} />
                )}
              </fieldset>
              )}

              {tumHatalar.length > 0 && (
                <div className="re-kural-hata">
                  <strong>Kurallara takıldı:</strong>
                  <ul>{tumHatalar.map((k, i) => <li key={i}>{k}</li>)}</ul>
                </div>
              )}
              {kuralHatalari && tumHatalar.length === 0 && (
                <div className="re-kural-tamam">✔ Kurallar uygun. "Kaydet" ile tamamlayın.</div>
              )}
              {modalHata && <div className="hata-kutu">{modalHata}</div>}

              <div className="re-dugmeler">
                {/* Not randevusunda kural yok; "Kuralları Denetle" de gösterilmez. */}
                {!yeni.notRandevu && (
                  <button className="btn btn-secondary" onClick={kuralDenetimi} disabled={islemde}>Kuralları Denetle</button>
                )}
                <button className="btn btn-primary" onClick={randevuVer}
                        disabled={islemde || (!yeni.notRandevu && (!yeni.planlamaId || !yeni.tarifeKod
                                  || (hazirlik?.odaGerekli && !yeni.odaAdi)))}>
                  💾 Kaydet
                </button>
              </div>
            </div>

            {/* SALT SEÇİM HAK LİSTESİ (kullanıcı talebi: 2026-09-22): kullanıcılar hangi hakkı
                kullandıklarına bakarak karar vermek istiyor. Burada YALNIZCA seçim yapılır —
                hak ekleme / düzenleme / silme yok; onlar sol alttaki HAKLAR penceresinde.
                Soldaki açılır liste ile aynı seçimi paylaşır. */}
            {!yeni.notRandevu && (
            <div className="re-yr-sag">
              <div className="re-hak-baslik">( {hasta.adi} ) Kullanılmamış Hakları · {kullanilmamisHaklar.length}</div>
              <div className="re-hak-tablo-kutu re-hak-sade">
                <table className="re-hak-tablo">
                  <thead>
                    <tr>
                      <th>Protokol</th><th>Hizmet</th><th className="sag">Fiyatı</th>
                      <th className="sag">Seans Ödeme</th><th>Türü</th><th>No</th>
                    </tr>
                  </thead>
                  <tbody>
                    {kullanilmamisHaklar.length === 0 && (
                      <tr><td colSpan={6} className="re-hak-bos">Kullanılmamış hak yok — aşağıdaki ➕ Yeni Paket ile satış planlaması açabilirsiniz.</td></tr>
                    )}
                    {kullanilmamisHaklar.map(h => {
                      const sirada = siradakiHakIdleri.has(h.id);
                      return (
                        <tr key={h.id}
                            className={`${String(h.id) === String(yeni.planlamaId) ? 'secili' : ''}${sirada ? '' : ' re-hak-sirasiz'}`}
                            onClick={() => sirada && hakSec(h.id)}
                            title={sirada ? 'Randevuyu bu hakka bağla' : 'Bu paketteki aynı hizmetin önceki hakkı kullanılmadan bu hak kullanılamaz'}>
                          <td>{h.protokol}</td>
                          <td>{h.hizmet}</td>
                          <td className="sag">{para(h.fiyat)}</td>
                          <td className="sag">{h.seansOdeme ? para(h.seansOdeme) : ''}</td>
                          <td>{h.odemeTuru}</td>
                          <td>{h.id}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              {/* ➕ Yeni Paket kısayolu soldaki kutu kaldırılınca buraya taşındı (2026-09-22). */}
              <div className="re-hak-salt">
                <p>
                  🔒 Bu liste yalnızca <b>seçim</b> içindir. Hak ekleme, düzenleme ve silme
                  hasta listesinin altındaki <b>HAKLAR</b> penceresinde yapılır.
                </p>
                <button className="btn btn-secondary" title="Yeni satış planlama (paket) aç"
                        onClick={() => setHaklarPencere({ baslangic: 'yeni', gun: secili.tarih, randevudan: true })}>➕ Yeni Paket</button>
              </div>
            </div>
            )}
          </div>
        </Pencere>
      )}

      {/* ============================ MODAL: SAAT KAPAMA ============================ */}
      {modal === 'kapat' && secili && (
        <Pencere baslik="Saat Kapama" kapat={pencereyiKapat}>
          <div className="re-tablo-form">
            <div><span>Tarih</span><b>{uzunTarih(secili.tarih)}</b></div>
            <div><span>Uzman</span><b>{uzman?.adi}</b></div>
            <div>
              <span>Kapama Süresi</span>
              <b>
                <select value={kapatma.dkSay} onChange={e => setKapatma(k => ({ ...k, dkSay: e.target.value }))}>
                  {sureSecenekleri(musait).map(n => <option key={n} value={n}>{n * periyot}</option>)}
                </select>
                <small> dk</small>
                <span className="re-saat-kutu">{secili.saat}</span>
                <span className="re-saat-kutu">{saatEkle(secili.saat, (Number(kapatma.dkSay) || 1) * periyot)}</span>
              </b>
            </div>
          </div>
          <label className="re-etiket">Açıklama</label>
          <textarea rows={4} value={kapatma.aciklama} onChange={e => setKapatma(k => ({ ...k, aciklama: e.target.value }))} />
          <p className="re-not">
            Hasta randevusu değil, yalnızca bu saati doluya çeker. Kabul veya satış kaydı oluşmaz.
            Randevu vermek için önce soldan hasta seçin.
          </p>
          {modalHata && <div className="hata-kutu">{modalHata}</div>}
          <div className="re-dugmeler">
            <button className="btn btn-secondary" onClick={pencereyiKapat}>Vazgeç</button>
            <button className="btn btn-primary" onClick={saatKapat} disabled={islemde}>💾 Kaydet</button>
          </div>
        </Pencere>
      )}

      {/* ============================ MODAL: RANDEVU TAŞI (yapıştır) ============================ */}
      {modal === 'tasi' && secili && kesilen && (
        <Pencere baslik="Randevu Taşı" kapat={pencereyiKapat}>
          {(!tasima || !tasima.h) && !modalHata && <div className="loading">Kurallar denetleniyor...</div>}
          {tasima?.h && (
            <>
              <div className="re-tablo-form">
                <div><span>Hasta</span><b className="re-buyuk">{tasima.h.adSoy}</b></div>
                <div><span>Eski Tarih ve Saat</span><b>{uzunTarih(String(tasima.h.eskiTarih).slice(0, 10))} · {tasima.h.eskiSaat} · {tasima.h.eskiDoktor}</b></div>
                <div><span>Yeni Tarih ve Saat</span><b className="re-tasi-yeni">{uzunTarih(secili.tarih)} · {secili.saat} · {tasima.h.yeniDoktor}</b></div>
                <div><span>Süre</span><b>{tasima.h.dakika} dakika</b></div>
                {tasima.h.odaGerekli && (
                  <div>
                    <span>Oda</span>
                    <b>
                      <select value={tasima.oda} onChange={e => setTasima(t => ({ ...t, oda: e.target.value }))}>
                        {tasima.h.bosOdalar.length === 0 && <option value="">BOŞ ODA YOK</option>}
                        {tasima.h.bosOdalar.map(o => <option key={o} value={o}>{o}</option>)}
                      </select>
                    </b>
                  </div>
                )}
              </div>

              {/* Not randevusu artık seçilmiyor, hedef SAATTEN geliyor (09:00–09:45) — 2026-09-21. */}
              <div className="re-tasi-tur">
                <label>{tasima.notRandevu
                  ? '📝 Hedef saat 09:00–09:45 arasında: NOT ALMA RANDEVUSU olarak taşınacak'
                  : 'GERÇEK RANDEVU olarak taşınacak'}</label>
              </div>

              {/* Yeni randevu kuralları — biri bile ihlal ediliyorsa taşınmaz. */}
              {tasima.h.hatalar.length > 0 ? (
                <div className="re-kural-hata">
                  <b>Yeni randevu kuralları sağlanmıyor, bu randevu buraya taşınamaz:</b>
                  <ul>{tasima.h.hatalar.map((k, i) => <li key={i}>{k}</li>)}</ul>
                </div>
              ) : (
                <div className="re-kural-tamam">✔ Yeni randevu verme kurallarının tümüne uyuyor.</div>
              )}

              <label className="re-tasi-sms">
                <input type="checkbox" checked={tasima.sms} disabled={!tasima.h.smsAcik}
                       onChange={e => setTasima(t => ({ ...t, sms: e.target.checked }))} />
                Hastaya taşıma SMS'i gönderilsin
                {!tasima.h.smsAcik && tasima.h.smsNeden && <small> ({tasima.h.smsNeden})</small>}
              </label>
              {tasima.sms && tasima.h.smsAcik && (
                <textarea rows={3} value={tasima.smsMetni} onChange={e => setTasima(t => ({ ...t, smsMetni: e.target.value }))} />
              )}
            </>
          )}

          {modalHata && <div className="hata-kutu">{modalHata}</div>}

          <div className="re-dugmeler">
            <button className="btn btn-secondary" onClick={pencereyiKapat}>Vazgeç</button>
            <button className="btn btn-primary" onClick={tasimaYap}
                    disabled={islemde || !tasima?.h || tasima.yukleniyor || tasima.h.hatalar.length > 0
                              || (tasima.h.odaGerekli && !tasima.oda)}>
              {islemde ? 'Taşınıyor...' : '✂ Buraya Taşı'}
            </button>
          </div>
        </Pencere>
      )}

      {/* ============================ MODAL: RANDEVU DETAYI ============================ */}
      {modal === 'detay' && (
        <Pencere baslik={detay?.tur === 0 ? 'Kapalı Saat' : 'Randevu'} kapat={pencereyiKapat}>
          {!detay && !modalHata && <div className="loading">Yükleniyor...</div>}
          {detay && (
            <>
              <div className="re-tablo-form">
                {detay.tur !== 0 && (
                  <>
                    <div><span>Hasta</span><b className="re-buyuk">{detay.adSoy}</b></div>
                    <div><span>Telefon</span><b>{detay.cepTel}</b></div>
                    <div><span>Hizmet</span><b>{detay.hizmet}</b></div>
                    <div><span>Protokol</span><b>{detay.masterProtNo}</b></div>
                  </>
                )}
                <div><span>Tarih</span><b>{uzunTarih(secili?.tarih)} · {detay.saat}</b></div>
                <div><span>Uzman</span><b>{detay.doktor}</b></div>
                <div><span>Kaydeden</span><b>{detay.who}</b></div>
                <div>
                  <span>Süre</span>
                  <b>
                    <select value={detay.dkSay} onChange={e => setDetay(d => ({ ...d, dkSay: e.target.value }))}>
                      {sureSecenekleri(musaitDetay).map(n => <option key={n} value={n}>{n * periyot}</option>)}
                    </select>
                    <small> dakika</small>
                  </b>
                </div>
                {detay.tur !== 0 && (
                  <div>
                    <span>Özel İstek</span>
                    <b>
                      <select value={detay.ozelIstekKod} onChange={e => setDetay(d => ({ ...d, ozelIstekKod: e.target.value }))}>
                        <option value={0}>YOK</option>
                        {(secenek?.ozelIstekler ?? []).map(o => <option key={o.kod} value={o.kod}>{o.adi}</option>)}
                      </select>
                    </b>
                  </div>
                )}
              </div>

              {/* GELDİ / GELMEDİ — reklam performansı (lead -> randevu -> geldi mi?) bununla
                  ölçülür (kullanıcı: "çok önemli", 2026-09-19). VB6 Command2/34/14/55. */}
              {detay.tur !== 0 && (
                <GeldiBolumu detay={detay} tamamlandi={(mesaj) => { setBilgi(mesaj); pencereyiKapat(); yukle(); }} />
              )}

              <label className="re-etiket">Açıklama</label>
              <textarea rows={3} value={detay.aciklama ?? ''} onChange={e => setDetay(d => ({ ...d, aciklama: e.target.value }))} />

              {modalHata && <div className="hata-kutu">{modalHata}</div>}

              {!silOnay && !yenidenAcik && (
                <div className="re-detay-dugmeler">
                  <button className="btn btn-danger" disabled={detay.faturali}
                          title={detay.faturali ? 'Çıkışı yapılmış (ön faturası kesilmiş) randevu iptal edilemez.' : ''}
                          onClick={() => (detay.tur !== 0 && detay.geldi === 1
                    ? setModalHata('Bu hasta randevusuna GELDİ olarak işaretli. Bu randevuyu iptal edebilmek için öncelikle GELMEDİ durumuna geri çevirmelisiniz.')
                    : setSilOnay(true))}>
                    {detay.tur === 0 ? '🔓 Kapatmayı Kaldır' : '🗑️ Randevu İptali'}
                  </button>
                  {detay.tur !== 0 && (
                    <button className="btn btn-secondary" onClick={randevuyuKes}
                            title="Randevuyu başka bir tarih / saat / uzmana taşımak için keser">
                      ✂️ Kes (Taşı)
                    </button>
                  )}
                  {detay.tur !== 0 && (
                    <button className="btn btn-secondary" onClick={() => setYenidenAcik(true)}
                            disabled={!smsBilgi?.yenidenAcik} title={smsBilgi?.neden || ''}>
                      📩 Yeniden SMS
                    </button>
                  )}
                  <button className="btn btn-primary" onClick={randevuGuncelle} disabled={islemde}>💾 Güncelle</button>
                </div>
              )}

              {/* VB6 "Yeniden SMS": SMS'ini silen hastaya randevu bilgisi tekrar gider —
                  hastalar bu SMS'i tarih/saat ve konum bağlantısı için hatırlatma notu gibi saklıyor. */}
              {yenidenAcik && smsBilgi && (
                <div className="re-sms-panel">
                  <strong>Yeniden SMS</strong>
                  <span className="re-sms-not">{smsBilgi.tel}</span>
                  <textarea className="re-sms-metni" rows={3} value={yenidenMetni} onChange={e => setYenidenMetni(e.target.value)} />
                  <div className="re-dugmeler">
                    <button className="btn btn-secondary" onClick={() => setYenidenAcik(false)}>Vazgeç</button>
                    <button className="btn btn-primary" disabled={islemde} onClick={async () => {
                      if (!window.confirm('Hastanıza YENİDEN SMS yollamak istiyor musunuz?')) return;
                      setModalHata(''); setIslemde(true);
                      try {
                        const { data } = await api.post(`/RandevuEkrani/${detay.id}/yeniden-sms`, { mesaj: yenidenMetni });
                        setBilgi(data.mesaj); setYenidenAcik(false);
                      } catch (err) {
                        setModalHata(err.response?.data?.hata || 'SMS yollanamadı.');
                      } finally { setIslemde(false); }
                    }}>📩 SMS Yolla</button>
                  </div>
                </div>
              )}

              {silOnay && (
                <div className="re-sil-onay">
                  <strong>{detay.tur === 0 ? 'Bu kapatma kaldırılsın mı?' : 'Bu randevu iptal edilsin mi?'}</strong>
                  <p>
                    {detay.masterProtNo > 0
                      ? 'Bu randevuyu İPTAL ETTİĞİNİZDE; kabul kaydı, muayene isteği ve (varsa) muayene sonucu da silinir, satış planlamadan doğan hak "kullanılmadı" olarak serbest bırakılır. Faturalanmış kayıtlar silinemez.'
                      : 'Bu kayıt silinir.'}
                  </p>
                  {/* VB6 "RANDEVU İPTALİ" penceresi: iptal SMS'i Gönderilsin / Gönderilmesin. */}
                  {detay.tur !== 0 && smsBilgi && (
                    <div className="re-iptal-sms">
                      <div className="re-gd-sms">
                        <span>SMS</span>
                        <label className="re-secim">
                          <input type="radio" checked={iptalSms} disabled={!smsBilgi.iptalAcik} onChange={() => setIptalSms(true)} /> Gönderilsin
                        </label>
                        <label className="re-secim">
                          <input type="radio" checked={!iptalSms} disabled={!smsBilgi.iptalAcik} onChange={() => setIptalSms(false)} /> Gönderilmesin
                        </label>
                        <small className="re-sms-not">{smsBilgi.iptalAcik ? smsBilgi.tel : smsBilgi.neden}</small>
                      </div>
                      {iptalSms && (
                        <textarea className="re-sms-metni" rows={3} value={iptalMetni} onChange={e => setIptalMetni(e.target.value)} />
                      )}
                    </div>
                  )}
                  <div className="re-dugmeler">
                    <button className="btn btn-secondary" onClick={() => setSilOnay(false)}>Vazgeç</button>
                    <button className="btn btn-danger" onClick={randevuSil} disabled={islemde}>Evet, iptal et</button>
                  </div>
                </div>
              )}
            </>
          )}
          {!detay && modalHata && <div className="hata-kutu">{modalHata}</div>}
        </Pencere>
      )}

      {/* HAKLAR penceresi EN SONDA: randevu penceresindeki kısayoldan açıldığında onun üstünde görünsün. */}
      {haklarPencere && hasta && (
        <HaklarPenceresi hasta={hasta} gun={haklarPencere.gun} baslangic={haklarPencere.baslangic}
                         kapat={() => setHaklarPencere(null)}
                         yeniPaket={haklarPencere.randevudan ? yeniHakKaydedildi : null}
                         degisti={haklarDegisti} />
      )}
    </div>
  );
}

// HAKLAR penceresi (kullanıcı talebi: 2026-09-20) — hastanın satış planlamadan doğan haklarına
// ilişkin TÜM işlemler burada: liste (protokoller, Kullanılmamış / Kullanılmış / Tümü, sayaçlar),
// Yeni Satış Planlama ve Hakları Düzenle. Önceden yalnızca randevu verirken açılabiliyordu.
//   yeniPaket: randevu penceresindeki kısayoldan açıldıysa verilir — yeni paket kaydedilince
//              pencere kapanır ve randevu penceresi yeni paketin ilk hakkını seçer.
function HaklarPenceresi({ hasta, gun, baslangic, kapat, yeniPaket, degisti }) {
  const [durum, setDurum] = useState('kullanilmamis');
  const [veri, setVeri] = useState({ kullanilmamis: 0, kullanilmis: 0, haklar: [] });
  const [secProtokol, setSecProtokol] = useState(null);
  const [yeniAcik, setYeniAcik] = useState(baslangic === 'yeni');
  const [duzenle, setDuzenle] = useState(null);
  const [hata, setHata] = useState('');
  const [bilgi, setBilgi] = useState('');

  const yukle = useCallback(async (d) => {
    try {
      const { data } = await api.get('/RandevuEkrani/hak-listesi', { params: { kayitNo: hasta.kayitNo, durum: d } });
      setVeri(data);
      return data;
    } catch (err) {
      setHata(err.response?.data?.hata || 'Satış hakları alınamadı.');
      return null;
    }
  }, [hasta.kayitNo]);

  useEffect(() => { yukle(durum); }, [yukle, durum]);

  const protokoller = [...new Set(veri.haklar.map(h => h.protokol))];
  const duzenlenecek = secProtokol ?? (protokoller.length === 1 ? protokoller[0] : null);
  const gorunen = secProtokol == null ? veri.haklar : veri.haklar.filter(h => h.protokol === secProtokol);

  const yeniKaydedildi = async (ortak, mesaj) => {
    if (yeniPaket) { yeniPaket(ortak, mesaj); return; }
    setYeniAcik(false);
    setDurum('kullanilmamis');
    await yukle('kullanilmamis');
    setSecProtokol(ortak);
    setBilgi(mesaj || '');
    degisti(mesaj);
  };

  const duzenlendi = async (ortak, mesaj) => {
    setDuzenle(null);
    const v = await yukle(durum);
    setSecProtokol(v?.haklar?.some(x => x.protokol === ortak) ? ortak : null);
    setBilgi(mesaj || '');
    degisti(mesaj);
  };

  return (
    <Pencere baslik={`Haklar · ${hasta.adi}`} genis kapat={kapat}>
      <div className="re-yr re-haklar-tek">
        {yeniAcik ? (
          <YeniHakPaneli hasta={hasta} gun={gun} kaydedildi={yeniKaydedildi}
                         kapat={() => (baslangic === 'yeni' && yeniPaket ? kapat() : setYeniAcik(false))} />
        ) : duzenle ? (
          <HakDuzenlePaneli hasta={hasta} ortak={duzenle} kapat={() => setDuzenle(null)} kaydedildi={duzenlendi} />
        ) : (
          <div className="re-yr-sag">
            <div className="re-hak-baslik">( {hasta.adi} ) Satış Planlamadan Doğan Hakları</div>
            {bilgi && <div className="basari-kutu re-haklar-bilgi">{bilgi}</div>}
            {hata && <div className="hata-kutu">{hata}</div>}
            <div className="re-hak-govde">
              <ul className="re-protokoller">
                <li className="baslik">Protokol</li>
                <li className={secProtokol == null ? 'secili' : ''} onClick={() => setSecProtokol(null)}>Tümü</li>
                {protokoller.map(p => (
                  <li key={p} className={secProtokol === p ? 'secili' : ''} onClick={() => setSecProtokol(p)}>{p || '—'}</li>
                ))}
              </ul>
              <div className="re-hak-tablo-kutu">
                <table className="re-hak-tablo">
                  <thead>
                    <tr>
                      <th>Hizmet</th><th className="sag">Toplam</th><th className="sag">Fiyatı</th>
                      <th className="sag">Peşin Ödeme</th><th>Kullanıldı</th><th>No</th>
                      <th className="sag">Seans Ödeme</th><th />
                    </tr>
                  </thead>
                  <tbody>
                    {gorunen.length === 0 && <tr><td colSpan={8} className="re-hak-bos">Kayıt yok.</td></tr>}
                    {gorunen.map(h => (
                      <tr key={h.id} className={h.kullanildi ? 'kullanildi' : ''} onClick={() => setSecProtokol(h.protokol)}>
                        <td>{h.hizmet}</td>
                        <td className="sag">{para(h.toplam)}</td>
                        <td className="sag">{para(h.fiyat)}</td>
                        <td className="sag">{para(h.pesinOdeme)}</td>
                        <td>{h.kullanildi ? 'Evet' : 'Hayır'}</td>
                        <td>{h.id}</td>
                        <td className="sag">{para(h.seansOdeme)}</td>
                        <td>{h.odemeTuru}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="re-hak-alt">
              <div className="re-hak-filtre">
                {[['kullanilmamis', 'Kullanılmamışları Göster', 'yesil'], ['kullanilmis', 'Kullanılmışları Göster', 'kirmizi'], ['tumu', 'Tümünü Göster', '']].map(([v, ad, sinif]) => (
                  <label key={v} className={sinif}>
                    <input type="radio" checked={durum === v} onChange={() => { setDurum(v); setSecProtokol(null); }} /> {ad}
                  </label>
                ))}
              </div>
              <div className="re-hak-sayac">
                <span className="yesil">Kullanılmamış Hakları <b>{veri.kullanilmamis}</b></span>
                <span className="kirmizi">Kullanılmış Hakları <b>{veri.kullanilmis}</b></span>
              </div>
              {/* İki işlem butonu yan yana, sağda (kullanıcı talebi: 2026-09-20). */}
              <div className="re-hak-islemler">
                <button className="btn re-btn-hak-duzenle" disabled={!duzenlenecek}
                        onClick={() => { setBilgi(''); setDuzenle(duzenlenecek); }}
                        title={duzenlenecek ? `${duzenlenecek} numaralı paketin haklarını düzenle / sil` : 'Soldaki Protokol listesinden (ya da tablodan) düzenlenecek paketi seçin'}>
                  ✎ Hakları Düzenle{duzenlenecek ? ` (${duzenlenecek})` : ''}
                </button>
                <button className="btn re-btn-yeni-hak" onClick={() => { setBilgi(''); setYeniAcik(true); }}>➕ Yeni Satış Planlama</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Pencere>
  );
}

// YENİ SATIŞ PLANLAMA KAYDI (yeni HAK) — VB6 SSPanel21 (kullanıcı talebi: 2026-09-19).
// Seans fiyatı: toplam / seans, 2 ondalık; bölünmeyen kuruş SON seansa (kullanıcı kararı) —
// sunucu da aynı hesabı bağımsız yapar, ekrandaki yalnızca gösterim.
function seansFiyatlari(toplam, seans) {
  const n = Number(seans) || 0;
  if (n < 1) return [];
  const t = Math.round((Number(toplam) || 0) * 100);            // kuruş
  const birim = Math.round(t / n);
  const liste = Array.from({ length: n }, () => birim);
  liste[n - 1] = t - birim * (n - 1);
  return liste.map(k => k / 100);
}

function YeniHakPaneli({ hasta, gun, kapat, kaydedildi }) {
  const [secenek, setSecenek] = useState(null);         // gruplar, kasa, kartlar, bankalar
  const [hizmet, setHizmet] = useState(null);           // { kod, adi }
  const [secimAcik, setSecimAcik] = useState(false);
  const [ara, setAra] = useState('');
  const [grupNe, setGrupNe] = useState(0);
  const [hizmetler, setHizmetler] = useState([]);
  const [fiyat, setFiyat] = useState({ standart: 0, sonPlan: 0 });
  const [seans, setSeans] = useState(1);
  const [toplam, setToplam] = useState('');
  const [satirlar, setSatirlar] = useState([]);          // { odendi, vaatTutar, vaatTur }
  const [aciklama, setAciklama] = useState('');
  const [tahsilatTuru, setTahsilatTuru] = useState('nakit');
  const [kartKod, setKartKod] = useState('');
  const [bankaKod, setBankaKod] = useState('');
  const [sonSatis, setSonSatis] = useState(null);
  const [hata, setHata] = useState('');
  const [islemde, setIslemde] = useState(false);

  useEffect(() => {
    api.get('/RandevuEkrani/yeni-hak/secenekler')
      .then(({ data }) => {
        setSecenek(data);
        setKartKod(data.kartlar?.[0]?.kod ?? '');
        setBankaKod(data.bankalar?.[0]?.kod ?? '');
      })
      .catch(err => setHata(err.response?.data?.hata || 'Seçenekler alınamadı.'));
  }, []);

  // Hizmet listesi (VB6 HAKLAR_HZMT_SEC): arama ve grup süzgeci.
  useEffect(() => {
    if (!secimAcik) return undefined;
    const t = setTimeout(() => {
      api.get('/RandevuEkrani/yeni-hak/hizmetler', { params: { ara, ne: grupNe || undefined } })
        .then(({ data }) => setHizmetler(data))
        .catch(() => setHizmetler([]));
    }, 200);
    return () => clearTimeout(t);
  }, [secimAcik, ara, grupNe]);

  const fiyatlar = seansFiyatlari(toplam, seans);

  // HESAPLA: ızgara yeniden kurulur; "Bunu Ödedi" ve vaatler sıfırlanır (VB6 gibi).
  const hesapla = (s = seans) => {
    setHata('');
    setSatirlar(Array.from({ length: Number(s) || 0 }, () => ({ odendi: false, vaatTutar: '', vaatTur: '' })));
  };

  const hizmetSec = async (h) => {
    setHizmet({ kod: h.kod, adi: h.adi });
    setSecimAcik(false);
    setSonSatis(null);
    try {
      const { data } = await api.get('/RandevuEkrani/yeni-hak/fiyatlar', { params: { kayitNo: hasta.kayitNo, hzmtKod: h.kod } });
      setFiyat(data);
    } catch { setFiyat({ standart: 0, sonPlan: 0 }); }
    if (toplam === '') setToplam('0');
    hesapla();   // VB6: seçimden sonra HESAPLA kendiliğinden çalışır
  };

  // ".." — "Bu fiyattan işlem yap": toplam = seans × fiyat, ızgara yeniden hesaplanır.
  const fiyattanIslem = (birim) => {
    setToplam(String(Math.round((Number(seans) || 0) * birim * 100) / 100));
    hesapla();
  };

  const sonSatisGoster = async () => {
    setHata('');
    if (!hizmet) { setHata('Önce SATIN ALINAN HİZMETİ seçiniz.'); return; }
    try {
      const { data } = await api.get('/RandevuEkrani/yeni-hak/son-satis', { params: { kayitNo: hasta.kayitNo, hzmtKod: hizmet.kod } });
      setSonSatis(data);
    } catch (err) { setHata(err.response?.data?.hata || 'Son satış bilgisi alınamadı.'); }
  };

  const satirDegis = (i, degisim) => setSatirlar(ss => ss.map((s, j) => (j === i ? { ...s, ...degisim } : s)));

  const pesin = satirlar.reduce((t, s, i) => t + (s.odendi ? (fiyatlar[i] || 0) : 0), 0);

  const kaydet = async () => {
    setHata('');
    if (satirlar.length === 0) { setHata('Lütfen SATIŞI HESAPLA butonuna basarak gerekli hesaplamaları yapınız.'); return; }
    if (!hizmet) { setHata('Lütfen VERİLECEK HİZMETİ belirleyiniz.'); return; }
    if (!window.confirm('Bu PLANLAMAYI kaydetmek istiyor musunuz?')) return;
    setIslemde(true);
    try {
      const { data } = await api.post('/RandevuEkrani/yeni-hak', {
        kayitNo: hasta.kayitNo,
        hzmtKod: hizmet.kod,
        seansSayisi: satirlar.length,
        toplam: Number(toplam) || 0,
        aciklama,
        tahsilatTuru,
        hesapKod: tahsilatTuru === 'kart' ? Number(kartKod) || 0 : tahsilatTuru === 'banka' ? Number(bankaKod) || 0 : 0,
        gun,
        satirlar: satirlar.map(s => ({
          odendi: s.odendi,
          vaatTutar: s.odendi ? null : (Number(s.vaatTutar) || null),
          vaatTur: s.odendi ? '' : s.vaatTur,
        })),
      });
      kaydedildi(data.ortakMasterProtNo, `${satirlar.length} seanslık yeni hak oluşturuldu (protokol ${data.ortakMasterProtNo}).`);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Satış planlama kaydedilemedi.');
    } finally {
      setIslemde(false);
    }
  };

  return (
    <div className="re-yr-sag re-yh">
      <div className="re-hak-baslik re-yh-baslik">
        <span>Yeni Satış Planlama Kaydı — {hasta.adi}</span>
        <button onClick={kapat} aria-label="Kapat" title="Hak listesine dön">✕</button>
      </div>

      <div className="re-yh-govde">
        <div className="re-yh-ust">
          <div className="re-tablo-form">
            <div>
              <span>Satın Alınan Hizmet</span>
              <b>
                <em className="re-yh-hizmet">{hizmet?.adi || '—'}</em>
                <button className="btn btn-secondary re-yh-kucuk" onClick={() => setSecimAcik(!secimAcik)}>SEÇ</button>
              </b>
            </div>
            <div>
              <span>Kaç Seans</span>
              <b>
                <select value={seans} onChange={e => { setSeans(Number(e.target.value)); hesapla(Number(e.target.value)); }}>
                  {Array.from({ length: 50 }, (_, i) => i + 1).map(n => <option key={n} value={n}>{n}</option>)}
                </select>
              </b>
            </div>
            <div>
              <span>Toplam Satış Tutarı</span>
              <b>
                <input className="re-yh-tutar" inputMode="decimal" value={toplam}
                       onChange={e => { setToplam(e.target.value.replace(',', '.').replace(/[^0-9.]/g, '')); hesapla(); }} />
                <small>TL ( KDV Dahil )</small>
              </b>
            </div>
          </div>

          <div className="re-yh-fiyatlar">
            <div><span>Standart Satış</span><b>{para(fiyat.standart)}</b>
              <button className="btn btn-secondary re-yh-kucuk" title="Bu fiyattan işlem yap" onClick={() => fiyattanIslem(fiyat.standart)} disabled={!hizmet}>..</button></div>
            <div><span>Son Plan Fiyatı</span><b>{para(fiyat.sonPlan)}</b>
              <button className="btn btn-secondary re-yh-kucuk" title="Bu fiyattan işlem yap" onClick={() => fiyattanIslem(fiyat.sonPlan)} disabled={!hizmet}>..</button></div>
            <button className="btn btn-primary" onClick={() => hesapla()} disabled={!hizmet}>HESAPLA</button>
            <button className="btn btn-secondary re-yh-son" onClick={sonSatisGoster}>Bu Hizmetin, Bu Hastaya Son Satış Fiyatı ?</button>
          </div>
        </div>

        {secimAcik && (
          <div className="re-yh-secim">
            <div className="re-yh-secim-arama">
              <input placeholder="Hizmet adı" value={ara} onChange={e => setAra(e.target.value)} autoFocus />
              <select value={grupNe} onChange={e => setGrupNe(Number(e.target.value))}>
                <option value={0}>Tüm gruplar</option>
                {(secenek?.gruplar ?? []).map(g => <option key={g.ne} value={g.ne}>{g.adi}</option>)}
              </select>
            </div>
            <ul>
              {hizmetler.length === 0 && <li className="bos">Hizmet bulunamadı.</li>}
              {hizmetler.map(h => (
                <li key={h.kod} onClick={() => hizmetSec(h)}><span>{h.kod}</span>{h.adi}</li>
              ))}
            </ul>
          </div>
        )}

        {sonSatis && (
          <div className="re-yh-bilgi">
            {sonSatis.var ? (
              <>
                <b>{hasta.adi} · {hizmet?.adi}</b><br />
                Tarih: {trTarih(sonSatis.islemTar)} · KDV'li Satış Fiyatı: {para(sonSatis.kdvliReel)} TL<br />
                Son paketindeki planlanan birim fiyat: {para(sonSatis.sonPlanBirim)} TL · Son paket toplamı: {para(sonSatis.sonPaketToplam)} TL
              </>
            ) : (
              <>{hasta.adi} isimli hastaya {hizmet?.adi} hizmeti daha önce hiç verilmemiş.</>
            )}
            <button onClick={() => setSonSatis(null)} aria-label="Kapat">✕</button>
          </div>
        )}

        <div className="re-yh-tablo-kutu">
          <table className="re-hak-tablo">
            <thead>
              <tr>
                <th>Bunu Ödedi</th><th>Hizmet</th><th className="sag">Fiyatı</th>
                <th className="sag">Ödeyeceği Tutar</th><th>Türü</th>
              </tr>
            </thead>
            <tbody>
              {satirlar.length === 0 && (
                <tr><td colSpan={5} className="re-hak-bos">Hizmeti seçip HESAPLA'ya basın.</td></tr>
              )}
              {satirlar.map((s, i) => (
                <tr key={i} className={s.odendi ? 'odendi' : ''}>
                  <td className="orta">
                    <input type="checkbox" checked={s.odendi}
                           onChange={e => satirDegis(i, { odendi: e.target.checked, ...(e.target.checked ? { vaatTutar: '', vaatTur: '' } : {}) })} />
                  </td>
                  <td>{hizmet?.adi}</td>
                  <td className="sag">{para(fiyatlar[i])}</td>
                  <td className="sag">
                    <input className="re-yh-vaat" inputMode="decimal" disabled={s.odendi} value={s.vaatTutar}
                           onChange={e => satirDegis(i, { vaatTutar: e.target.value.replace(',', '.').replace(/[^0-9.]/g, '') })} />
                  </td>
                  <td>
                    <select disabled={s.odendi} value={s.vaatTur} onChange={e => satirDegis(i, { vaatTur: e.target.value })}>
                      <option value="">SEÇ</option><option value="Nakit">Nakit</option><option value="K.Kartı">K.Kartı</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="re-yh-alt">
          <div className="re-yh-xler">
            <button className="btn btn-secondary re-yh-kucuk" title="Tümünü ödendi işaretle"
                    onClick={() => setSatirlar(ss => ss.map(s => ({ ...s, odendi: true, vaatTutar: '', vaatTur: '' })))}>( X )</button>
            <button className="btn btn-secondary re-yh-kucuk" title="Tüm işaretleri kaldır"
                    onClick={() => setSatirlar(ss => ss.map(s => ({ ...s, odendi: false })))}>(   )</button>
          </div>
          <label className="re-yh-aciklama">
            <span>Paket Açıklama</span>
            <textarea rows={2} maxLength={250} value={aciklama} onChange={e => setAciklama(e.target.value)} />
          </label>
          <div className="re-yh-tahsilat">
            <span>Tahsilat</span><b>{para(pesin)} TL</b>
          </div>
        </div>

        {pesin > 0 && (
          <div className="re-yh-tur">
            <span>Tahsilat Türü</span>
            {[['nakit', 'Nakit'], ['kart', 'Kredi Kartı'], ['banka', 'Banka']].map(([v, ad]) => (
              <label key={v} className="re-secim">
                <input type="radio" checked={tahsilatTuru === v} onChange={() => setTahsilatTuru(v)} /> {ad}
              </label>
            ))}
            {tahsilatTuru === 'nakit' && (
              <small className={secenek?.kasa ? '' : 're-sms-not'}>{secenek?.kasa ? secenek.kasa.adi : 'Kasa (vezne) hesabınız tanımlı değil'}</small>
            )}
            {tahsilatTuru === 'kart' && (
              <select value={kartKod} onChange={e => setKartKod(e.target.value)}>
                {(secenek?.kartlar ?? []).map(k => <option key={k.kod} value={k.kod}>{k.adi}</option>)}
              </select>
            )}
            {tahsilatTuru === 'banka' && (
              <select value={bankaKod} onChange={e => setBankaKod(e.target.value)}>
                {(secenek?.bankalar ?? []).map(k => <option key={k.kod} value={k.kod}>{k.adi}</option>)}
              </select>
            )}
          </div>
        )}

        {hata && <div className="hata-kutu re-yh-hata">{hata}</div>}

        <div className="re-dugmeler">
          <button className="btn btn-secondary" onClick={kapat}>Vazgeç</button>
          <button className="btn btn-primary" onClick={kaydet} disabled={islemde || satirlar.length === 0}>💾 KAYDET</button>
        </div>
      </div>
    </div>
  );
}

// "Hakları Düzenle" — VB6 Command40/45/58/41/50'nin RİSKSİZ karşılığı (kullanıcı talebi: 2026-09-20).
// Kullanılmış ya da peşin ödenmiş hak KİLİTLİDİR (değiştirilemez, silinemez); diğerlerinde fiyat,
// ödeyeceği tutar ve türü düzenlenir, hak silinebilir. Kayıtta paketin toplamı yeniden doğrulanır
// (toplam = peşin + ileride ödenecek). Sunucu aynı kuralları ayrıca uygular.
function HakDuzenlePaneli({ hasta, ortak, kapat, kaydedildi }) {
  const [paket, setPaket] = useState(null);
  const [satirlar, setSatirlar] = useState([]);
  const [aciklama, setAciklama] = useState('');
  const [hata, setHata] = useState('');
  const [islemde, setIslemde] = useState(false);
  const [onay, setOnay] = useState(false);

  useEffect(() => {
    api.get('/RandevuEkrani/yeni-hak/paket', { params: { ortak, kayitNo: hasta.kayitNo } })
      .then(({ data }) => {
        setPaket(data);
        setAciklama(data.aciklama || '');
        setSatirlar(data.satirlar.map(s => ({ ...s, fiyatG: String(s.fiyat), vaatG: s.vaatTutar ? String(s.vaatTutar) : '', turG: s.vaatTur || '', sil: false })));
      })
      .catch(err => setHata(err.response?.data?.hata || 'Paket bilgileri alınamadı.'));
  }, [ortak, hasta.kayitNo]);

  const sayi = (v) => Number(String(v || '0').replace(',', '.')) || 0;
  const degis = (id, alan) => { setOnay(false); setHata(''); setSatirlar(ss => ss.map(s => (s.id === id ? { ...s, ...alan } : s))); };

  const kalan = satirlar.filter(s => !s.sil);
  const toplam = kalan.reduce((a, s) => a + sayi(s.fiyatG), 0);
  const pesin = kalan.reduce((a, s) => a + (s.odenen || 0), 0);
  const vaat = kalan.reduce((a, s) => a + sayi(s.vaatG), 0);
  const fark = Math.round((toplam - pesin - vaat) * 100) / 100;
  const silinenSayisi = satirlar.filter(s => s.sil).length;

  const kaydet = async () => {
    setHata(''); setIslemde(true);
    try {
      await api.put(`/RandevuEkrani/yeni-hak/paket/${ortak}`, {
        kayitNo: hasta.kayitNo,
        aciklama,
        satirlar: kalan.map(s => ({ id: s.id, fiyat: sayi(s.fiyatG), vaatTutar: sayi(s.vaatG), vaatTur: s.turG })),
        silinenler: satirlar.filter(s => s.sil).map(s => s.id),
      });
      kaydedildi(ortak, kalan.length === 0
        ? `${ortak} numaralı satış planlama paketi silindi.`
        : `${ortak} numaralı satış planlama güncellendi${silinenSayisi ? ` (${silinenSayisi} hak silindi)` : ''}.`);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Satış planlama güncellenemedi.');
      setOnay(false);
    } finally {
      setIslemde(false);
    }
  };

  return (
    <div className="re-yr-sag re-yh">
      <div className="re-hak-baslik re-yh-baslik">
        <span>Hakları Düzenle — Protokol {ortak} · {hasta.adi}</span>
        <button onClick={kapat} aria-label="Kapat">✕</button>
      </div>
      <div className="re-yh-govde">
        {!paket && !hata && <div className="loading">Yükleniyor...</div>}
        {paket && (
          <>
            <div className="re-yh-tablo-kutu">
              <table className="re-hak-tablo">
                <thead>
                  <tr>
                    <th>No</th><th>Hizmet</th><th className="sag">Fiyatı</th><th className="sag">Peşin</th>
                    <th className="sag">Ödeyeceği Tutar</th><th>Türü</th><th>Durum</th><th />
                  </tr>
                </thead>
                <tbody>
                  {satirlar.map(s => (
                    <tr key={s.id} className={`${s.kilitli ? 'kullanildi' : ''}${s.sil ? ' re-hd-sil' : ''}`}>
                      <td>{s.id}</td>
                      <td>{s.hizmet}</td>
                      <td className="sag">
                        {s.kilitli ? para(s.fiyat) : (
                          <input className="re-yh-vaat" inputMode="decimal" disabled={s.sil} value={s.fiyatG}
                                 onChange={e => degis(s.id, { fiyatG: e.target.value.replace(',', '.').replace(/[^0-9.]/g, '') })} />
                        )}
                      </td>
                      <td className="sag">{s.odenen ? para(s.odenen) : ''}</td>
                      <td className="sag">
                        {s.kilitli ? (s.vaatTutar ? para(s.vaatTutar) : '') : (
                          <input className="re-yh-vaat" inputMode="decimal" disabled={s.sil} value={s.vaatG}
                                 onChange={e => degis(s.id, { vaatG: e.target.value.replace(',', '.').replace(/[^0-9.]/g, '') })} />
                        )}
                      </td>
                      <td>
                        {s.kilitli ? s.vaatTur : (
                          <select disabled={s.sil} value={s.turG} onChange={e => degis(s.id, { turG: e.target.value })}>
                            <option value="">SEÇ</option><option value="Nakit">Nakit</option><option value="K.Kartı">K.Kartı</option>
                          </select>
                        )}
                      </td>
                      <td className="re-hd-durum">
                        {s.kullanildi ? `🔒 Kullanıldı${s.randevuTar ? ` (${trTarih(s.randevuTar)})` : ''}`
                          : s.pesin ? '🔒 Peşin ödendi' : 'Düzenlenebilir'}
                      </td>
                      <td>
                        {!s.kilitli && (
                          <button className={`btn ${s.sil ? 'btn-secondary' : 'btn-danger'} re-yh-kucuk`}
                                  onClick={() => degis(s.id, { sil: !s.sil })}
                                  title={s.sil ? 'Silmekten vazgeç' : 'Bu hakkı paketten sil'}>
                            {s.sil ? '↩' : '🗑️'}
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="re-hd-ozet">
              <span>Toplam <b>{para(toplam)}</b></span>
              <span>Peşin <b>{para(pesin)}</b></span>
              <span>İleride Ödenecek <b>{para(vaat)}</b></span>
              <span className={fark === 0 ? 'tamam' : 'eksik'}>
                {fark === 0 ? '✔ Ödemeler tutarlı' : fark > 0 ? `Eksik: ${para(fark)}` : `Fazla: ${para(-fark)}`}
              </span>
            </div>

            <label className="re-yh-aciklama">
              <span>Paket Açıklama</span>
              <textarea rows={2} maxLength={250} value={aciklama} onChange={e => { setAciklama(e.target.value); setOnay(false); }} />
            </label>

            <p className="re-not">🔒 Kullanılmış ya da peşin ödenmiş haklar değiştirilemez ve silinemez.</p>
          </>
        )}

        {hata && <div className="hata-kutu re-yh-hata">{hata}</div>}

        {onay ? (
          <div className="re-hk-onay">
            <p>{kalan.length === 0
              ? 'Paketin tüm hakları SİLİNECEK. Emin misiniz?'
              : silinenSayisi > 0
                ? `${silinenSayisi} hak SİLİNECEK ve diğer değişiklikler kaydedilecek. Emin misiniz?`
                : 'Bu PLANLAMAYI güncellemek istiyor musunuz?'}</p>
            <div className="re-dugmeler">
              <button className="btn btn-secondary" onClick={() => setOnay(false)} disabled={islemde}>Hayır</button>
              <button className={`btn ${silinenSayisi ? 'btn-danger' : 'btn-primary'}`} onClick={kaydet} disabled={islemde}>
                {islemde ? 'Kaydediliyor...' : 'Evet'}
              </button>
            </div>
          </div>
        ) : (
          <div className="re-dugmeler">
            <button className="btn btn-secondary" onClick={kapat}>Vazgeç</button>
            <button className="btn btn-primary" onClick={() => setOnay(true)}
                    disabled={!paket || islemde || (kalan.length > 0 && fark !== 0)}>💾 KAYDET</button>
          </div>
        )}
      </div>
    </div>
  );
}

// ÇIKIŞ YAP penceresi (kullanıcı talebi: 2026-09-20) — VB6 Banko KABUL ekranındaki "çıkış"ın
// otomatik hali, yalnız ÜCRETLİ tarifede. Sorular: İşlem Tutarı, Ödeme Şekli, Kasa/POS/Banka.
//   - İşlem tutarı hakkın fiyatıyla gelir; değiştirilirse gerekçe (banko notu) zorunlu.
//   - Ödeme zorunlu değil; peşin ödenmiş hakta varsayılan tahsilat 0. Eksik tahsilat notla olur.
//   - Ön kabul notu (KABUL.BANKONOT) personele ne yapacağını söyler, ekranda gösterilir.
// Sunucu aynı kuralları ayrıca denetler; kayıt tek işlemde yapılır (yarım kayıt kalmaz).
function CikisPenceresi({ randId, h, kapat, tamamlandi }) {
  const [tutar, setTutar] = useState(String(h.islemTutari));
  const [tahsilat, setTahsilat] = useState(String(h.hakPesin || h.tahsilatYasagi ? 0 : h.islemTutari));
  const [tur, setTur] = useState(h.kasa ? 'nakit' : 'kart');
  const [kartKod, setKartKod] = useState(String(h.kartlar?.[0]?.kod ?? ''));
  const [bankaKod, setBankaKod] = useState(String(h.bankalar?.[0]?.kod ?? ''));
  const [not, setNot] = useState('');
  const [onay, setOnay] = useState(false);
  const [hata, setHata] = useState('');
  const [islemde, setIslemde] = useState(false);

  const sayi = (v) => Math.round((Number(String(v || '0').replace(',', '.')) || 0) * 100) / 100;
  const t = sayi(tutar);
  const th = sayi(tahsilat);
  const tutarDegisti = t !== sayi(h.islemTutari);
  const eksik = !h.hakPesin && !h.tahsilatYasagi && th < t;
  const notGerekli = tutarDegisti || eksik;
  const temiz = (v) => v.replace(',', '.').replace(/[^0-9.]/g, '');

  const onayla = async () => {
    setHata(''); setIslemde(true);
    try {
      const { data } = await api.post(`/RandevuEkrani/${randId}/cikis`, {
        islemTutari: t, bankoNot: not, tahsilatTutari: th,
        tahsilatTuru: th > 0 ? tur : null,
        hesapKod: tur === 'kart' ? Number(kartKod) : tur === 'banka' ? Number(bankaKod) : 0,
      });
      tamamlandi(data.mesaj);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Çıkış yapılamadı.');
      setOnay(false);
    } finally {
      setIslemde(false);
    }
  };

  return (
    <Pencere baslik={`Çıkış Yap · ${h.adSoy}`} kapat={kapat}>
      <div className="re-tablo-form">
        <div><span>Tarife</span><b>{h.tarifeAdi}</b></div>
        <div><span>Hizmet</span><b>{h.satirlar.map(s => `${s.hizmet}${s.adet > 1 ? ` ×${s.adet}` : ''}`).join(', ')}</b></div>
        {h.hakPesin && <div><span>Paket Ödemesi</span><b className="re-cikis-pesin">Bu seans paket satışında PEŞİN ödenmiş</b></div>}
        {h.vaatTutar > 0 && <div><span>Ödeme Sözü</span><b>{para(h.vaatTutar)} TL {h.vaatTur}</b></div>}
      </div>

      {h.bankoNot && <div className="re-cikis-not"><b>Ön kabul notu:</b> {h.bankoNot}</div>}

      <div className="re-cikis-kutu">
        <label>1. İşlem Tutarı (KDV dahil)</label>
        <div className="re-cikis-satir">
          <input inputMode="decimal" value={tutar} onChange={e => { setTutar(temiz(e.target.value)); setOnay(false); }} />
          <span>TL</span>
          {tutarDegisti && <small className="re-sure-uyari">hakkın fiyatı {para(h.islemTutari)} TL — gerekçe yazınız</small>}
        </div>

        <label>2. Ödeme (tahsil edilen tutar)</label>
        <div className="re-cikis-satir">
          <input inputMode="decimal" value={tahsilat} onChange={e => { setTahsilat(temiz(e.target.value)); setOnay(false); }} />
          <span>TL</span>
          {th === 0 && <small>ödeme alınmayacak</small>}
        </div>

        {th > 0 && (
          <>
            <label>3. Ödeme Şekli ve Hesap</label>
            <div className="re-cikis-tur">
              {[['nakit', 'Nakit'], ['kart', 'Kredi Kartı'], ['banka', 'Banka']].map(([v, ad]) => (
                <label key={v}><input type="radio" checked={tur === v} onChange={() => { setTur(v); setOnay(false); }} /> {ad}</label>
              ))}
            </div>
            <div className="re-cikis-satir">
              {tur === 'nakit' && (h.kasa ? <b>{h.kasa.adi}</b> : <small className="re-sure-uyari">Kasa (vezne) hesabınız tanımlı değil</small>)}
              {tur === 'kart' && (
                <select value={kartKod} onChange={e => setKartKod(e.target.value)}>
                  {(h.kartlar ?? []).map(k => <option key={k.kod} value={k.kod}>{k.adi}</option>)}
                </select>
              )}
              {tur === 'banka' && (
                <select value={bankaKod} onChange={e => setBankaKod(e.target.value)}>
                  {(h.bankalar ?? []).map(k => <option key={k.kod} value={k.kod}>{k.adi}</option>)}
                </select>
              )}
            </div>
          </>
        )}
      </div>

      <div className="re-cikis-ozet">
        <span>Fatura <b>{para(t)}</b></span>
        <span>Tahsilat <b>{para(th)}</b></span>
        <span className={t - th > 0 ? 'eksik' : ''}>
          {t - th > 0 ? `Hastanın borcu kalır: ${para(t - th)}` : t - th < 0 ? `Fazla ödeme (hesabına): ${para(th - t)}` : '✔ Tam ödeme'}
        </span>
      </div>

      <label className="re-etiket">Banko Notu {notGerekli && <span className="re-sure-uyari">(zorunlu: {tutarDegisti ? 'tutar değişti' : 'eksik tahsilat'})</span>}</label>
      <textarea rows={2} maxLength={200} value={not} onChange={e => { setNot(e.target.value); setOnay(false); }} />

      {hata && <div className="hata-kutu" style={{ whiteSpace: 'pre-line' }}>{hata}</div>}

      {onay ? (
        <div className="re-hk-onay">
          <p>Hastanın ÇIKIŞ işlemini yaparak kaydı kapatmak istiyor musunuz? (Kapatılan bir kaydın içine yeni hizmet eklenemez)</p>
          <div className="re-dugmeler">
            <button className="btn btn-secondary" onClick={() => setOnay(false)} disabled={islemde}>Hayır</button>
            <button className="btn btn-primary" onClick={onayla} disabled={islemde}>{islemde ? 'Kaydediliyor...' : 'Evet, çıkışı yap'}</button>
          </div>
        </div>
      ) : (
        <div className="re-dugmeler">
          <button className="btn btn-secondary" onClick={kapat}>Vazgeç</button>
          <button className="btn btn-primary" onClick={() => setOnay(true)} disabled={notGerekli && !not.trim()}>💳 Çıkışı Onayla</button>
        </div>
      )}
    </Pencere>
  );
}

// GELDİ / GELMEDİ bölümü (randevu detay penceresi içinde).
//   GELDİ: ödeme sözü (VAAT_TUTAR) varsa önce VB6'daki hatırlatma adımı; sonra memnuniyet
//          SMS'i seçimi (daha önce gönderilmemişse varsayılan Evet) ve onay.
//   GELMEDİ: VB6'daki uyarıyla onay.
function GeldiBolumu({ detay, tamamlandi }) {
  const [adim, setAdim] = useState(null);          // null | 'vaat' | 'onay' | 'gelmedi'
  const [bilgi, setBilgi] = useState(null);         // sunucudan geldi-hazırlık
  const [yorumSms, setYorumSms] = useState(false);
  // VB6: "Muayene yapılacak mı" (varsayılan Hayır) ve muayene hekimi (yalnız MD=1 hekimler).
  const [muayene, setMuayene] = useState(false);
  const [muayeneDok, setMuayeneDok] = useState('');
  const [yorumMetni, setYorumMetni] = useState('');
  const [hata, setHata] = useState('');
  const [islemde, setIslemde] = useState(false);
  const geldi = detay.geldi === 1;
  // ÇIKIŞ YAP (2026-09-20): yalnız GELDİ + ÜCRETLİ tarifede aktif; nedeni sunucu söyler.
  const [cikis, setCikis] = useState(null);         // cikis-hazirlik yanıtı
  const [cikisAcik, setCikisAcik] = useState(false);

  useEffect(() => {
    if (!geldi) { setCikis(null); return; }
    api.get(`/RandevuEkrani/${detay.id}/cikis-hazirlik`)
      .then(({ data }) => setCikis(data))
      .catch(() => setCikis({ uygun: false, neden: 'Çıkış bilgileri alınamadı.' }));
  }, [geldi, detay.id]);

  const geldiBaslat = async () => {
    setHata('');
    try {
      const { data } = await api.get(`/RandevuEkrani/${detay.id}/geldi-hazirlik`);
      setBilgi(data);
      setYorumSms(data.yorumSmsVarsayilan);
      setYorumMetni(data.yorumSmsMetni || '');
      setAdim(Number(data.vaatTutar) !== 0 ? 'vaat' : 'onay');
    } catch (err) {
      setHata(err.response?.data?.hata || 'Geldi bilgisi alınamadı.');
    }
  };

  const geldiKaydet = async () => {
    setHata('');
    if (muayene && !muayeneDok) { setHata('Muayene yapılacak ise kimin yapacağını da seçmelisiniz.'); return; }
    if (!window.confirm('Hastayı Randevusuna GELDİ olarak işaretlemek istiyor musunuz?')) return;
    setIslemde(true);
    try {
      const { data } = await api.post(`/RandevuEkrani/${detay.id}/geldi`, {
        yorumSms, yorumSmsMetni: yorumMetni, muayene, muayeneDokKod: Number(muayeneDok) || 0,
      });
      tamamlandi(['Hasta randevusuna GELDİ olarak işaretlendi.', data.sms].filter(Boolean).join(' · '));
    } catch (err) {
      setHata(err.response?.data?.hata || 'Geldi onayı kaydedilemedi.');
    } finally {
      setIslemde(false);
    }
  };

  const gelmediKaydet = async () => {
    setHata(''); setIslemde(true);
    try {
      await api.post(`/RandevuEkrani/${detay.id}/gelmedi`);
      tamamlandi('Randevu GELMEDİ olarak işaretlendi.');
    } catch (err) {
      setHata(err.response?.data?.hata || 'Gelmedi işaretlenemedi.');
    } finally {
      setIslemde(false);
    }
  };

  return (
    <div className={`re-gd${geldi ? ' gd-evet' : ''}`}>
      <div className="re-gd-bas">
        <span className="re-gd-durum">{geldi ? '✔ RANDEVUYA GELDİ' : '● HENÜZ GELMEDİ'}</span>
        {!adim && (geldi
          ? (
            <span className="re-gd-sag">
              <button className="btn re-btn-cikis" onClick={() => setCikisAcik(true)} disabled={!cikis?.uygun}
                      title={cikis?.uygun ? 'Ön faturayı kes ve ödemeyi al' : (cikis?.neden || 'Kontrol ediliyor...')}>
                {cikis?.cikisYapildi ? '✔ ÇIKIŞI YAPILDI' : '💳 ÇIKIŞ YAP'}
              </button>
              {/* Çıkışı yapılmış randevu GELMEDİ'ye çevrilemez — sunucu da reddeder (2026-09-20). */}
              <button className="btn btn-secondary" disabled={cikis?.cikisYapildi}
                      title={cikis?.cikisYapildi ? 'Çıkışı yapılmış (ön faturası kesilmiş) randevu GELMEDİ olarak işaretlenemez. Önce "Fatura İptal" prosedürü uygulanmalıdır.' : ''}
                      onClick={() => setAdim('gelmedi')}>
                ✖ GELMEDİ olarak işaretle
              </button>
            </span>
          )
          : (
            <span className="re-gd-sag">
              <button className="btn re-btn-cikis" disabled title="Hasta GELDİ olarak işaretlenmeden çıkış yapılamaz">💳 ÇIKIŞ YAP</button>
              <button className="btn re-btn-geldi" onClick={geldiBaslat}>✔ GELDİ</button>
            </span>
          ))}
      </div>
      {geldi && cikis && !cikis.uygun && cikis.neden && <div className="re-cikis-neden">{cikis.neden}</div>}

      {cikisAcik && cikis?.uygun && (
        <CikisPenceresi randId={detay.id} h={cikis} kapat={() => setCikisAcik(false)}
                        tamamlandi={(m) => { setCikisAcik(false); tamamlandi(m); }} />
      )}

      {adim === 'vaat' && (
        <div className="re-gd-adim uyari">
          <p>Bu hastanın <b>{para(bilgi.vaatTutar)} TL</b> ödeme sözü var. Lütfen hastaya gereken hatırlatmayı yapınız.</p>
          <div className="re-gd-dugmeler">
            <button className="btn btn-secondary" onClick={() => setAdim(null)}>HASTA ÖDEME KONUSUNDA SORUN ÇIKARDI İŞLEMİ DEVAM ETME</button>
            <button className="btn btn-primary" onClick={() => setAdim('onay')}>TAMAM GEREKEN HATIRLATMAYI YAPTIM İŞLEME DEVAM ET</button>
          </div>
        </div>
      )}

      {adim === 'onay' && bilgi && (
        <div className="re-gd-adim">
          <div className="re-gd-sms">
            <span>Muayene yapılacak mı?</span>
            <label className="re-secim">
              <input type="radio" checked={muayene} onChange={() => setMuayene(true)} /> Evet
            </label>
            <label className="re-secim">
              <input type="radio" checked={!muayene} onChange={() => { setMuayene(false); setMuayeneDok(''); }} /> Hayır
            </label>
            {muayene && (
              <select value={muayeneDok} onChange={e => setMuayeneDok(e.target.value)} className="re-muayene-dok">
                <option value="">— muayeneyi yapacak hekim —</option>
                {(bilgi.muayeneDoktorlari ?? []).map(d => <option key={d.kod} value={d.kod}>{d.adi}</option>)}
              </select>
            )}
          </div>
          <div className="re-gd-sms">
            <span>Memnuniyet SMS'i</span>
            <label className="re-secim">
              <input type="radio" checked={yorumSms} disabled={!bilgi.yorumSmsAcik} onChange={() => setYorumSms(true)} /> Evet
            </label>
            <label className="re-secim">
              <input type="radio" checked={!yorumSms} disabled={!bilgi.yorumSmsAcik} onChange={() => setYorumSms(false)} /> Hayır
            </label>
            <small className="re-sms-not">
              {!bilgi.yorumSmsAcik ? bilgi.yorumSmsNeden
                : bilgi.yorumSmsDahaOnce ? "Bu hastaya daha önce yorum SMS'i yollanmış" : bilgi.hastaTel}
            </small>
          </div>
          {yorumSms && (
            <textarea className="re-sms-metni" rows={2} value={yorumMetni} onChange={e => setYorumMetni(e.target.value)} />
          )}
          <div className="re-gd-dugmeler">
            <button className="btn btn-secondary" onClick={() => setAdim(null)}>Vazgeç</button>
            <button className="btn re-btn-geldi" onClick={geldiKaydet} disabled={islemde}>✔ GELDİ olarak işaretle</button>
          </div>
        </div>
      )}

      {adim === 'gelmedi' && (
        <div className="re-gd-adim uyari">
          <p>Bu randevuyu GELMEDİ olarak işaretlediğinizde, muayene isteği ve (varsa) muayene sonucu da silinecektir.
             GELMEDİ olarak işaretlemek istiyor musunuz?</p>
          <div className="re-gd-dugmeler">
            <button className="btn btn-secondary" onClick={() => setAdim(null)}>Vazgeç</button>
            <button className="btn btn-danger" onClick={gelmediKaydet} disabled={islemde}>Evet, GELMEDİ</button>
          </div>
        </div>
      )}

      {hata && <div className="hata-kutu">{hata}</div>}
    </div>
  );
}

// Telefon yazımı VB6 maskesi gibi: 0-5##-###-##-## (en fazla 11 rakam; baştaki 0 yazılmasa da eklenir).
function telRakam(s) {
  let d = String(s || '').replace(/\D/g, '');
  if (d && d[0] !== '0') d = '0' + d;
  return d.slice(0, 11);
}
function telGoster(d) {
  const p = [d.slice(0, 1), d.slice(1, 4), d.slice(4, 7), d.slice(7, 9), d.slice(9, 11)].filter(Boolean);
  return p.join('-');
}

// "Hızlı Hasta Kaydı" — VB6 SSPanel4 (kullanıcı talebi: 2026-09-19).
//   mod 'yeni'    = sol alttaki YENİ HASTA KAYDI (minimal kimlik kartı; istenirse ilk muayene hakkı)
//   mod 'duzenle' = yanındaki buton, seçili hastanın kimlik bilgilerini günceller
// Sunucu "aynı isimde hasta var" / "isim değişiyor" uyarısı dönerse pencere içinde sorulur.
function HastaKayitPenceresi({ mod, hasta, gun, kapat, kaydedildi }) {
  const duzenle = mod === 'duzenle';
  const [f, setF] = useState(() => (duzenle && hasta ? {
    adi: hasta.adi || '', cins: hasta.cins === 'K' ? 'K' : 'E',
    cep: telRakam(hasta.cepTel), diger: telRakam(hasta.digerTel) === '0' ? '' : telRakam(hasta.digerTel),
    tc: hasta.tcKimlik || '', email: hasta.email || '', notlar: hasta.notlar || '',
    cinsTercih: hasta.cinsTercih || 0, muayeneHak: false,
  } : {
    adi: '', cins: 'E', cep: '05', diger: '', tc: '', email: '', notlar: '', cinsTercih: 0, muayeneHak: false,
  }));
  const [muayeneVar, setMuayeneVar] = useState(false);
  const [onayMesaji, setOnayMesaji] = useState('');
  const [hata, setHata] = useState('');
  const [islemde, setIslemde] = useState(false);
  const adRef = useRef(null);

  useEffect(() => { adRef.current?.focus(); }, []);
  useEffect(() => {
    if (duzenle) return;
    api.get('/RandevuEkrani/hasta-kayit/secenekler')
      .then(({ data }) => setMuayeneVar(!!data.muayeneHak))
      .catch(() => setMuayeneVar(false));
  }, [duzenle]);

  const deg = (k, v) => { setF(x => ({ ...x, [k]: v })); setHata(''); setOnayMesaji(''); };

  const gonder = async (onay) => {
    setHata(''); setIslemde(true);
    const govde = {
      adi: f.adi, cins: f.cins, cepTel: f.cep, digerTel: f.diger, tcKimlik: f.tc, email: f.email,
      notlar: f.notlar, cinsTercih: Number(f.cinsTercih) || 0, muayeneHak: !duzenle && f.muayeneHak, gun, onay,
    };
    try {
      const { data } = duzenle
        ? await api.put(`/RandevuEkrani/hasta/${hasta.kayitNo}`, govde)
        : await api.post('/RandevuEkrani/hasta', govde);
      if (data.onayMesaji) { setOnayMesaji(data.onayMesaji); return; }
      kaydedildi(data.kayitNo, f.adi.trim(), duzenle ? 'Hasta bilgileri güncellendi.'
        : `Hasta kaydedildi. Hasta No: ${data.kayitNo}${govde.muayeneHak ? ' · İlk muayene hakkı tanımlandı.' : ''}`);
    } catch (err) {
      setHata(err.response?.data?.hata || (duzenle ? 'Hasta güncellenemedi.' : 'Hasta kaydedilemedi.'));
    } finally {
      setIslemde(false);
    }
  };

  return (
    <Pencere baslik={duzenle ? 'Hasta Bilgilerini Güncelle' : 'Hızlı Hasta Kaydı'} kapat={kapat}>
      <div className="re-tablo-form re-hk">
        <div>
          <span className="re-zorunlu">Adı - Soyadı</span>
          <b><input ref={adRef} value={f.adi} maxLength={30} onChange={e => deg('adi', e.target.value)} /></b>
        </div>
        <div>
          <span className="re-zorunlu">Cinsiyeti</span>
          <b>
            <select value={f.cins} onChange={e => deg('cins', e.target.value)}>
              <option value="E">E</option>
              <option value="K">K</option>
            </select>
          </b>
        </div>
        <div>
          <span className="re-zorunlu">Cep Telefonu</span>
          <b><input value={telGoster(f.cep)} inputMode="numeric" placeholder="0-5__-___-__-__"
                    onChange={e => deg('cep', telRakam(e.target.value))} /></b>
        </div>
        {!duzenle && muayeneVar && (
          <div className="re-hk-muayene">
            <label><input type="radio" checked={!f.muayeneHak} onChange={() => deg('muayeneHak', false)} /> Muayene Yok</label>
            <label><input type="radio" checked={f.muayeneHak} onChange={() => deg('muayeneHak', true)} /> Muayene HAK olarak Tanımla</label>
          </div>
        )}
        <div>
          <span>TC Kimlik No</span>
          <b><input value={f.tc} inputMode="numeric" maxLength={11}
                    onChange={e => deg('tc', e.target.value.replace(/\D/g, '').slice(0, 11))} /></b>
        </div>
        <div>
          <span>e-mail</span>
          <b><input value={f.email} maxLength={50} onChange={e => deg('email', e.target.value)} /></b>
        </div>
        <div>
          <span>Diğer Telefonu</span>
          <b><input value={telGoster(f.diger)} inputMode="numeric" placeholder="0-___-___-__-__"
                    onChange={e => deg('diger', telRakam(e.target.value))} /></b>
        </div>
        <div className="re-hk-not">
          <span>NOTLAR</span>
          <textarea rows={3} maxLength={255} value={f.notlar} onChange={e => deg('notlar', e.target.value)} />
        </div>
        <div>
          <span>Hoca Cinsiyet Tercihi</span>
          <b>
            <select value={f.cinsTercih} onChange={e => deg('cinsTercih', Number(e.target.value))}>
              <option value={0}>Farketmez</option>
              <option value={1}>Kadın Hoca</option>
              <option value={2}>Erkek Hoca</option>
            </select>
          </b>
        </div>
      </div>

      {!duzenle && (
        <div className="re-hk-bilgi">Sarı alanlar zorunludur, diğer bilgilerini kliniğe geldiği zaman tamamlayabilirsiniz.</div>
      )}

      {hata && <div className="hata-kutu re-hk-hata">{hata}</div>}

      {onayMesaji ? (
        <div className="re-hk-onay">
          <p>{onayMesaji}</p>
          <div className="re-dugmeler">
            <button className="btn btn-secondary" onClick={() => setOnayMesaji('')} disabled={islemde}>Hayır</button>
            <button className="btn btn-primary" onClick={() => gonder(true)} disabled={islemde}>Evet, devam et</button>
          </div>
        </div>
      ) : (
        <div className="re-dugmeler">
          <button className="btn btn-secondary" onClick={kapat} disabled={islemde}>Vazgeç</button>
          <button className="btn btn-primary" onClick={() => gonder(false)} disabled={islemde}>
            {islemde ? 'Kaydediliyor...' : duzenle ? 'Güncelle' : 'Kaydet'}
          </button>
        </div>
      )}
    </Pencere>
  );
}

// "Hastanın Tüm Randevuları" — VB6 Command7 + Command63 (kullanıcı talebi: 2026-09-19).
//   - Satıra ÇİFT TIK (ya da ›) → o randevunun uzmanı ve haftası açılır, saat ortalanır.
//   - Kutucukla seçilenler AYNI TARİH ve SAATTE başka uzmana taşınır. Her randevu sunucuda yeni
//     randevu kurallarından ayrı ayrı geçer; geçemeyen taşınmaz, nedeni satırında yazar.
function HastaRandevulariPenceresi({ hasta, kapat, git, tasindi }) {
  const [liste, setListe] = useState(null);
  const [uzmanlar, setUzmanlar] = useState([]);
  const [secili, setSecili] = useState([]);
  const [hedefDok, setHedefDok] = useState('');
  const [onay, setOnay] = useState(false);
  const [sonuc, setSonuc] = useState({});   // id -> { basarili, mesaj }
  const [hata, setHata] = useState('');
  const [islemde, setIslemde] = useState(false);

  const yukleListe = useCallback(async () => {
    try {
      const { data } = await api.get(`/RandevuEkrani/hasta/${hasta.kayitNo}/randevular`);
      setListe(data);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Randevular alınamadı.');
      setListe([]);
    }
  }, [hasta.kayitNo]);

  useEffect(() => { yukleListe(); }, [yukleListe]);
  useEffect(() => {
    api.get('/RandevuEkrani/uzmanlar', { params: { kapsam: 'hepsi' } })
      .then(({ data }) => { setUzmanlar(data); setHedefDok(d => d || String(data[0]?.kod ?? '')); })
      .catch(() => setUzmanlar([]));
  }, []);

  const secDegis = (id) => {
    setOnay(false);
    setSecili(s => (s.includes(id) ? s.filter(x => x !== id) : [...s, id]));
  };

  const hedefAdi = uzmanlar.find(u => String(u.kod) === String(hedefDok))?.adi ?? '';

  const tasi = async () => {
    setHata(''); setIslemde(true);
    try {
      const { data } = await api.post('/RandevuEkrani/uzmana-tasi', { randIdler: secili, hedefDokKod: Number(hedefDok) });
      const s = {};
      data.forEach(x => { s[x.id] = { basarili: x.basarili, mesaj: x.mesaj }; });
      setSonuc(s);
      const tasinan = data.filter(x => x.basarili).length;
      setSecili(data.filter(x => !x.basarili).map(x => x.id));
      setOnay(false);
      await yukleListe();
      if (tasinan > 0) tasindi(`${tasinan} randevu ${hedefAdi} isimli uzmana taşındı${tasinan < data.length ? `, ${data.length - tasinan} randevu taşınamadı` : ''}.`);
      else setHata('Seçili randevuların hiçbiri taşınamadı — nedenleri satırlarında yazıyor.');
    } catch (err) {
      setHata(err.response?.data?.hata || 'Taşıma yapılamadı.');
    } finally {
      setIslemde(false);
    }
  };

  return (
    <Pencere baslik={`Hastanın Tüm Randevuları · ${hasta.adi}`} genis kapat={kapat}>
      <div className="re-hr">
        <div className="re-hr-tablo">
          <table>
            <thead>
              <tr>
                <th>Seç</th><th>Tarih</th><th>Saat</th><th>Muhasebe</th><th>Uzman</th>
                <th>Türü</th><th>Hizmet</th><th>Açıklama</th><th />
              </tr>
            </thead>
            <tbody>
              {liste === null && <tr><td colSpan={9} className="re-hr-bos">Yükleniyor...</td></tr>}
              {liste?.length === 0 && <tr><td colSpan={9} className="re-hr-bos">Bu hastanın randevusu yok.</td></tr>}
              {liste?.map(r => {
                const s = sonuc[r.id];
                return (
                  <React.Fragment key={r.id}>
                    <tr className={secili.includes(r.id) ? 'secili' : ''} onDoubleClick={() => git(r)}
                        title="Çift tıklayın: randevunun sayfasına gider">
                      <td className="re-hr-sec" onDoubleClick={e => e.stopPropagation()}>
                        <input type="checkbox" checked={secili.includes(r.id)} onChange={() => secDegis(r.id)} />
                      </td>
                      <td>{trTarih(r.tarih)}</td>
                      <td>{r.saat}</td>
                      <td>{r.muhasebe ? 'OK' : '-'}</td>
                      <td>{r.doktor}</td>
                      <td>{r.turu}</td>
                      <td>{r.hizmet}</td>
                      <td className="re-hr-ack">{r.aciklama}</td>
                      <td><button className="btn btn-secondary re-hr-git" onClick={() => git(r)} title="Randevunun sayfasına git">›</button></td>
                    </tr>
                    {s && (
                      <tr className={`re-hr-sonuc ${s.basarili ? 'ok' : 'hata'}`}>
                        <td colSpan={9}>{s.basarili ? '✔ ' : '✖ '}{s.mesaj}</td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>

        {hata && <div className="hata-kutu">{hata}</div>}

        <div className="re-hr-tasi">
          <span>Seçili randevuları ({secili.length})</span>
          <select value={hedefDok} onChange={e => { setHedefDok(e.target.value); setOnay(false); }}>
            {uzmanlar.map(u => <option key={u.kod} value={u.kod}>{u.adi}</option>)}
          </select>
          <span>isimli personele taşı (aynı tarih ve saat)</span>
          <button className="btn btn-primary" disabled={secili.length === 0 || !hedefDok || islemde}
                  onClick={() => setOnay(true)}>TAŞI</button>
        </div>

        {onay && (
          <div className="re-hk-onay">
            <p>
              Seçili {secili.length} randevu <b>{hedefAdi}</b> isimli personelin AYNI TARİH ve SAATİNE taşınacak.
              Her randevu yeni randevu verilirken aranan şartlardan geçirilir (saat boş ve süre boyunca sığıyor mu,
              uzman bu hizmeti verebiliyor mu, hasta tercihleri, günlük 10 saat, oda ...). Şartı sağlamayan
              randevu taşınmaz. Taşınan randevunun kabul (mali) kayıtları da yeni uzmana geçer.
            </p>
            <div className="re-dugmeler">
              <button className="btn btn-secondary" onClick={() => setOnay(false)} disabled={islemde}>Vazgeç</button>
              <button className="btn btn-danger" onClick={tasi} disabled={islemde}>{islemde ? 'Taşınıyor...' : 'Evet, taşı'}</button>
            </div>
          </div>
        )}
      </div>
    </Pencere>
  );
}

// VB6'daki başlık çubuklu alt pencerelerin karşılığı. Zemine tıklamak ya da ✕ kapatır.
//
// hedefRef verilirse pencere o alanın TAM ÜSTÜNDE ve aynı boyutta açılır — Yeni Randevu
// penceresi çizelge + renk açıklaması alanını kaplar (kullanıcı talebi: 2026-09-19). Alan
// dar ekranda çok küçükse (tek sütuna düşmüş düzen) normal ortalanmış pencereye döner.
function Pencere({ baslik, genis, hedefRef, kapat, children }) {
  const [konum, setKonum] = useState(null);
  const zeminRef = useRef(null);

  useEffect(() => {
    // Üst üste açık pencerelerde (Randevu Ver + Haklar) Esc yalnızca EN ÜSTTEKİNİ kapatır.
    const tus = (e) => {
      if (e.key !== 'Escape') return;
      const hepsi = document.querySelectorAll('.re-modal-zemin');
      if (hepsi[hepsi.length - 1] === zeminRef.current) kapat();
    };
    window.addEventListener('keydown', tus);
    return () => window.removeEventListener('keydown', tus);
  }, [kapat]);

  useLayoutEffect(() => {
    // hedefRef kalkınca yerleşim de kalkmalı: yoksa pencere ölçüleri üzerinde kalıp
    // dar moda dönmüyordu (kullanıcı bildirimi: 2026-09-22).
    if (!hedefRef?.current) { setKonum(null); return undefined; }
    // Genişlik çizelgeden alınır; yükseklik ise menü çubuğunun hemen altından ekranın altına
    // kadar uzar — çizelgenin kendi yüksekliği yetmiyordu ve pencere kayıyordu
    // (kullanıcı bildirimi: 2026-09-19). Dar ekranda (telefon) yerleşik değil, tam ekran açılır.
    const olc = () => {
      const r = hedefRef.current?.getBoundingClientRect();
      if (!r || window.innerWidth <= 1100 || r.width < 900) { setKonum(null); return; }
      const ust = (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 90) + 8;
      setKonum({ left: r.left, top: ust, width: r.width, height: window.innerHeight - ust - 8 });
    };
    olc();
    window.addEventListener('resize', olc);
    window.addEventListener('scroll', olc, true);
    return () => {
      window.removeEventListener('resize', olc);
      window.removeEventListener('scroll', olc, true);
    };
  }, [hedefRef]);

  const yerlesik = !!konum;

  return (
    <div ref={zeminRef} className={`re-modal-zemin${yerlesik ? ' yerlesik' : ''}`}
         onMouseDown={e => { if (e.target === e.currentTarget) kapat(); }}>
      <div className={`re-modal${genis ? ' genis' : ''}`} role="dialog" aria-modal="true"
           style={yerlesik ? { position: 'fixed', ...konum, maxWidth: 'none' } : undefined}>
        <div className="re-modal-bas">
          <strong>{baslik}</strong>
          <button onClick={kapat} aria-label="Kapat">✕</button>
        </div>
        <div className="re-modal-govde">{children}</div>
      </div>
    </div>
  );
}

export default RandevuEkrani;
